//import tags
import React, { useState, useEffect } from "react";
import { useAppContext } from "./../../components/Context";

//import tags
import parse from "html-react-parser";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";
import { Link, useParams } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";

//import resources
import Bannerinside from "../../assets/image/insidebanner.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faLocationCrosshairs,
  faBed,
  faDoorOpen,
  faLayerGroup,
  faHashtag,
  faMobileScreen,
  faChevronRight,
  faWifi,
  faBuilding,
  faStreetView,
  faCalendar,
  faBuildingShield,
  faBuildingColumns,
  faStarHalf,
  faStar,
  faBuildingFlag,
  faBuildingNgo,
  faBuildingWheat,
  faBuildingUn,
  faCodeCommit,
  faCode,
  faListNumeric,
  faCheck,
  faCheckCircle,
  faEnvelope,
  faLandmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  faHeart as faHeartRegular,
  faClone,
  faCalendarDays,
  faFlag,
  faCheckSquare,
} from "@fortawesome/free-regular-svg-icons";

import "swiper/css";
import "swiper/css/navigation";

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";

//api
import { get_property_details } from "../../api/Api";
import { faCodepen } from "@fortawesome/free-brands-svg-icons";

//import options
import * as Options from "../../components/utils/PropertyOptions";

// checkbox group fields saved as JSON arrays
const arrayFields = [
  "communications",
  "additionaldetails",
  "road",
  "hotwater",
  "heating",
  "generalamenities",
  "furniture",
  "technic",
  "security",
  "smarthouse",
  "additionaladvantages",
  "additionalsecurity",
  "allowed",
  "facade1",
  "buildingmaterial",
  "doorandwindow",
  "overlap",
  "overlapmaterial",
  "fundament",
];

const parseArrayFields = (data) => {
  if (!data || typeof data != "object") {
    return data;
  }

  const parsed = { ...data };

  arrayFields.forEach((field) => {
    if (typeof parsed[field] == "string") {
      try {
        const value = JSON.parse(parsed[field]);
        parsed[field] = Array.isArray(value) && value.length > 0 ? value : null;
      } catch (error) {
        parsed[field] = parsed[field].split(",").map((item) => item.trim());
      }
    }
  });

  return parsed;
};

function Detail({ locale }) {
  const baseUrl = "https://api.relux.ge";

  const { getenumbykey, setFavoritesCount } = useAppContext();

  //get locale
  const { t } = useTranslation();

  const { id, slug } = useParams();

  const [property, setProperty] = useState(false);
  const [toggleView, setToggleView] = useState("0");
  const [favorites, setFavorites] = useState([]);
  const [message, setMessage] = useState("");
  const [currentCurrency, setCurrentCurrency] = useState("GEL");
  const [sortBy, setSortBy] = useState("0");
  const [showFullText, setShowFullText] = useState(false);

  const toggleText = () => {
    setShowFullText(!showFullText);
  };

  const toggleViewHandler = () => {
    setToggleView(!toggleView);
  };

  //get favorites if saved
  useEffect(() => {
    const storedFavorites = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavorites(storedFavorites);
  }, []);

  //set favorites
  const toggleFavorite = (id) => {
    let updatedFavorites;

    if (favorites.includes(id)) {
      updatedFavorites = favorites.filter((favId) => favId !== id);
      toast.error(t("removed_from_fav"), {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      updatedFavorites = [...favorites, id];
      toast.success(t("added_to_fav"), {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    setFavorites(updatedFavorites);

    localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
  };

  //set recently viewed
  useEffect(() => {
    const recentlyViewedItems =
      JSON.parse(localStorage.getItem("recentlyViewed")) || [];
    const updatedRecentlyViewed = [
      slug,
      ...recentlyViewedItems.filter((recId) => recId !== slug),
    ];

    if (updatedRecentlyViewed.length > 10) {
      updatedRecentlyViewed.pop();
    }

    localStorage.setItem(
      "recentlyViewed",
      JSON.stringify(updatedRecentlyViewed),
    );
  }, [slug]);

  //set favorites count context
  useEffect(() => {
    setFavoritesCount(null);
  }, [favorites]);

  const toggleCurrency = (currency) => {
    setCurrentCurrency(currency);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const header = {
          Authorization: "Bearer " + localStorage.getItem("token"),
          Locale: locale,
        };

        // checkbox groups come as JSON strings; arrays make includes() match exact values
        get_property_details(
          (data) => setProperty(parseArrayFields(data)),
          header,
          slug,
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (!property) {
      fetchData();
    }
  }, [property]);

  const firstImage = property.image1;

  // helpers for rendering fields that come from Add.js
  const hasValue = (value) =>
    value !== undefined && value !== null && value !== "";

  const optionLabel = (options, value) =>
    options.find((option) => option.value === value)?.label ?? value;

  // icon + label + value box (used in features / details sections)
  const renderInfoBox = (label, value, suffix) =>
    hasValue(value) ? (
      <Col xxl={4} key={label}>
        <div className="propertyCharacteristicsSingleBox">
          <div className="propertyCharacteristicsSingleBoxLeft">
            <FontAwesomeIcon icon={faBuilding} />
          </div>
          <div className="propertyCharacteristicsSingleBoxRight">
            <p>{label}</p>
            <h5>
              {value}
              {suffix}
            </h5>
          </div>
        </div>
      </Col>
    ) : null;

  // checkbox field with optional area / amount fields
  const renderParamBox = (field, label, { space, amount } = {}) =>
    property?.[field] == "yes" ? (
      <div className="mainParamBox" key={field}>
        <div className="paramIcon">
          <FontAwesomeIcon icon={faCheckSquare} />
        </div>
        <div className="paramText">
          <h5>{label}</h5>
          {space && hasValue(property?.[space]) ? (
            <h6>
              ფართი კვ.მ:
              <strong>
                {property[space]} მ<sup>2</sup>
              </strong>
            </h6>
          ) : (
            ""
          )}
          {amount && hasValue(property?.[amount]) ? (
            <p>
              რაოდენობა:
              <strong>{property[amount]}</strong>
            </p>
          ) : (
            ""
          )}
          {!space && !amount ? (
            <p>
              <strong>კი</strong>
            </p>
          ) : (
            ""
          )}
        </div>
      </div>
    ) : null;

  // label + value row inside hidden details sections
  const renderValueParam = (label, value) =>
    hasValue(value) ? (
      <Col xxl={12} key={label}>
        <div className="mainParamBox mb-12">
          <div className="paramIcon">
            <FontAwesomeIcon icon={faBuilding} />
          </div>
          <div className="paramText">
            <h5>{label}</h5>
            <h6>
              <strong>{value}</strong>
            </h6>
          </div>
        </div>
      </Col>
    ) : null;

  // GEL / USD / EUR amounts of one field as a single row
  const renderCurrencyParam = (label, prefix) =>
    ["gel", "usd", "eur"].some((cur) => hasValue(property?.[prefix + cur]))
      ? renderValueParam(
        label,
        ["gel", "usd", "eur"]
          .filter((cur) => hasValue(property?.[prefix + cur]))
          .map((cur) => `${property[prefix + cur]} ${cur.toUpperCase()}`)
          .join(" / "),
      )
      : null;

  // small checked item (list style)
  const renderListCheck = (field, label) =>
    property?.[field] == "yes" ? (
      <Col xxl={4} key={field}>
        <div className="mainListParamBox">
          <div className="paramListIcon">
            <FontAwesomeIcon icon={faCheckSquare} />
          </div>
          <div className="paramListText">
            <h5>{label}</h5>
          </div>
        </div>
      </Col>
    ) : null;

  // checked values of a checkbox group: [[value, label], ...]
  const renderGroupItems = (field, items) =>
    items.map(([value, label]) =>
      property?.[field]?.includes(value) ? (
        <Col xxl={4} key={value}>
          <div className="mainListParamBox">
            <div className="paramListIcon">
              <FontAwesomeIcon icon={faCheckSquare} />
            </div>
            <div className="paramListText">
              <h5>{label}</h5>
            </div>
          </div>
        </Col>
      ) : null,
    );

  // near object row with distance
  const renderNearObject = (field, label, distanceField) =>
    property?.[field] ? (
      <Row className="w-100 mb-2" key={field}>
        <Col xxl={6}>
          <div className="mainListParamBox">
            <div className="paramListIcon">
              <FontAwesomeIcon icon={faCheckSquare} />
            </div>
            <div className="paramListText">
              <h5>{label}</h5>
            </div>
          </div>
        </Col>
        {property?.[distanceField] ? (
          <Col xxl={6}>
            <div className="mainListParamBox">
              <div className="paramListText">
                <h5>{property[distanceField]} მ</h5>
              </div>
            </div>
          </Col>
        ) : (
          ""
        )}
      </Row>
    ) : null;

  const newNearObjects = [
    ["mountain", "მთა"],
    ["canyon", "კანიონი"],
    ["waterfall", "ჩანჩქერი"],
    ["botanic", "ბოტანიკური ბაღი"],
    ["zoo", "ზოოპარკი"],
    ["funicular", "ფუნიკულიორი"],
    ["stadium", "სტადიონი"],
    ["concert_hall", "საკონცერტო დარბაზი"],
    ["clinic", "კლინიკა"],
    ["port", "პორტი"],
    ["aquapark", "აკვაპარკი"],
    ["bath", "აბანო"],
    ["entertainment_center", "გასართობი ცენტრი"],
    ["church_monastery", "ეკლესია მონასტერი"],
    ["fortress", "ციხე-სიმაგრე"],
    ["house_museum", "სახლ-მუზეუმი"],
    ["dendrological_park", "დენდროლოგიური პარკი"],
  ];

  const finishingMaterials = [
    ["floorCover", "იატაკის საფარი"],
    ["ceilingCover", "ჭერის საფარი"],
    ["bathroomFloor", "აბაზანის საფარი"],
    ["mixers", "შემრევები"],
    ["wallFinish", "კედლის მოპირკეთება"],
    ["interiorDoors", "ოთახშორისი კარები (შიდა)"],
    ["kitchenFurniture", "სამზარეულოს გარნიტურა"],
    ["kitchenSurface", "სამზარეულოს ზედაპირი"],
    ["lighting", "განათება"],
    ["kitchenAppliances", "სამზარეულოს ტექნიკა"],
    ["entranceDoor", "შესასვლელი კარი"],
  ];

  return (
    <div className="main">
      <section className="propertyDetailsSection">
        <Container>
          <Row>
            <Col xxl={12}>
              <div className="shortBreadcumb">
                <div className="shortBreadcumbLeft">
                  <h1>
                    {typeof property == "object" &&
                      property?.transaction_type != null
                      ? getenumbykey(parse(property.transaction_type), 'transaction_type') + " "
                      : ""}
                    {typeof property == "object" &&
                      property?.property_type != null
                      ? getenumbykey(parse(property.property_type), 'property_type')
                      : ""}
                  </h1>
                </div>
                <div className="shortBreadcumbRight">
                  <ul>
                    <li>
                      <Link to="/">{t("home")}</Link>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faChevronRight} />
                    </li>
                    <li>{t("statements")}</li>
                  </ul>
                </div>
              </div>
            </Col>

            {/* {id ?? id}
                        {slug ?? slug} */}

            <Col xxl={12}>
              {message && (
                <div className="addedToFafourites">
                  <h4>{message}</h4>
                </div>
              )}
              <div className="mainImageSlider">
                {typeof property == "object" ? (
                  <Swiper
                    modules={[Navigation, A11y]}
                    spaceBetween={5}
                    slidesPerView={1}
                    navigation
                    scrollbar={{ draggable: true }}
                  >
                    {Array.from({ length: 15 }, (_, i) => `image${i + 1}`).map(
                      (imageKey, index) =>
                        property[imageKey] && property[imageKey] != null ? (
                          <SwiperSlide key={index}>
                            <div className="singleProductImage">
                              <Image
                                src={`${baseUrl}/storage/property/${property.image_folder}/${property[imageKey]}`}
                                alt={`Property image ${index + 1}`}
                              />
                            </div>
                          </SwiperSlide>
                        ) : (
                          ""
                        ),
                    )}
                  </Swiper>
                ) : (
                  <div className="singleProductImage">
                    <Skeleton height={500} />
                  </div>
                )}

                <div
                  className={`singleProductGridTag ${property.statement_type === "exclusive"
                      ? "exclusiveAd"
                      : "reluxAd"
                    }`}
                >
                  <Link to="/">
                    <h4>
                      {typeof property == "object" &&
                        property?.statement_type != null
                        ? getenumbykey(parse(property.statement_type), 'statement_type')
                        : ""}
                    </h4>
                  </Link>
                </div>

                <div
                  className="singleProductFavourite"
                  onClick={() => toggleFavorite(property?.id)}
                >
                  {favorites.includes(property?.id) ? (
                    <FontAwesomeIcon icon={faHeart} />
                  ) : (
                    <FontAwesomeIcon icon={faHeartRegular} />
                  )}
                </div>
              </div>
            </Col>

            <Col xxl={8}>
              <div className="propertyDetailsLeft">
                <div className="propertyDetailsTags">
                  <div className="singleTag">
                    {typeof property == "object" &&
                      property?.property_type != null ? (
                      getenumbykey(parse(property.property_type), 'property_type')
                    ) : (
                      <Skeleton width={100} />
                    )}
                  </div>
                  <div className="singleTag">
                    {typeof property == "object" && property?.city != null ? (
                      Options.cityOptions.find(option => option.value === property.city)?.label
                    ) : (
                      <Skeleton width={100} />
                    )}
                  </div>
                </div>

                <h2>
                  {typeof property == "object" &&
                    property?.transaction_type != null
                    ? getenumbykey(parse(property.transaction_type), 'transaction_type') + ", "
                    : ""}
                  {typeof property == "object" &&
                    property?.property_type != null
                    ? getenumbykey(parse(property.property_type), 'property_type') + ", "
                    : ""}
                  {typeof property == "object" &&
                    property?.property_status != null
                    ? getenumbykey(parse(property.property_status), 'property_status') + " "
                    : ""}
                </h2>

                <div className="singlePropertyLocation">
                  <FontAwesomeIcon icon={faLocationCrosshairs} />
                  <p>

                    {typeof property == "object" && property?.ubani != null ? (
                      (Options.ubani.find(option => option.value === property.ubani && option.city === property.city)?.label ?? property.ubani) + ", "
                    ) : ""}
                    {typeof property == "object" && property?.ubani1 != null
                      ? property.ubani1 + ", "
                      : ""}
                    {typeof property == "object" && property?.ubani2 != null
                      ? property.ubani2 + ", "
                      : ""}
                    {typeof property == "object" && property?.ubani3 != null
                      ? property.ubani3 + ", "
                      : ""}
                    {typeof property == "object" && property?.street_address != null
                      ? property.street_address + ", "
                      : ""}
                    {typeof property == "object" && property?.destrict != null ? (
                      Options.destrictOptions.find(option => option.value === property.destrict)?.label + ", "
                    ) : ""}
                    {typeof property == "object" && property?.region != null ? (
                      Options.districtOptions.find(option => option.value === property.region)?.label + ", "
                    ) : ""}
                    {typeof property == "object" && property?.municipality != null ? (
                      Options.municipalOptions.find(option => option.value === property.municipality)?.label + ", "
                    ) : ""}
                    {typeof property == "object" && property?.village != null
                      ? property.village + ", "
                      : ""}
                    {typeof property == "object" && property?.address != null
                      ? property.address
                      : ""}
                    {typeof property == "object" && property?.postal_code != null
                      ? ", " + property.postal_code
                      : ""}
                  </p>
                </div>

                <div className="propertyDetailsData">
                  <p>
                    <FontAwesomeIcon icon={faHashtag} />
                    <strong>
                      {typeof property == "object" && property?.id != null
                        ? property.id
                        : ""}
                    </strong>
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faCalendarDays} />
                    <strong>
                      {typeof property === "object" && property?.created_at
                        ? new Date(property.created_at).toLocaleString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          },
                        )
                        : ""}
                    </strong>
                  </p>
                </div>

                <div className="singlePropertyMiniBox">
                  {(() => {
                    switch (property?.property_type) {
                      case "land":
                        return (
                          <div className="singlePropertyMini" title={t("area")}>
                            <FontAwesomeIcon icon={faClone} />:
                            <span>
                              {t("area")}
                              <strong>
                                {property?.area != null ? property.area : ""}
                              </strong>
                              მ<sup>2</sup>
                            </span>
                          </div>
                        );
                      case "apartment":
                        return (
                          <>
                            <div
                              className="singlePropertyMini"
                              title={t("bedroom")}
                            >
                              <FontAwesomeIcon icon={faBed} />
                              <span>
                                {t("bedroom")}
                                <strong>
                                  {property?.bedrooms != null
                                    ? property.bedrooms
                                    : ""}
                                </strong>
                              </span>
                            </div>
                            <div
                              className="singlePropertyMini"
                              title={t("room")}
                            >
                              <FontAwesomeIcon icon={faDoorOpen} />
                              <span>
                                {t("room")}
                                <strong>
                                  {property?.rooms != null
                                    ? property.rooms
                                    : ""}
                                </strong>
                              </span>
                            </div>
                            <div
                              className="singlePropertyMini"
                              title={t("floor")}
                            >
                              <FontAwesomeIcon icon={faLayerGroup} />
                              <span>
                                {t("floor")}
                                <strong>
                                  {property?.floor != null
                                    ? property.floor
                                    : ""}
                                </strong>
                              </span>
                            </div>
                            <div
                              className="singlePropertyMini"
                              title={t("area")}
                            >
                              <FontAwesomeIcon icon={faClone} />
                              <span>
                                {t("area")}
                                <strong>
                                  {property?.area != null ? property.area : ""}
                                </strong>
                                მ<sup>2</sup>
                              </span>
                            </div>
                          </>
                        );
                      case "business":
                        return (
                          <>
                            <div
                              className="singlePropertyMini"
                              title={t("area")}
                            >
                              <FontAwesomeIcon icon={faClone} />
                              <span>
                                {t("area")}
                                <strong>
                                  {property?.area != null ? property.area : ""}
                                </strong>
                                მ<sup>2</sup>
                              </span>
                            </div>
                            <div
                              className="singlePropertyMini"
                              title={t("room")}
                            >
                              <FontAwesomeIcon icon={faDoorOpen} />
                              <span>
                                {t("room")}
                                <strong>
                                  {property?.rooms != null
                                    ? property.rooms
                                    : ""}
                                </strong>
                              </span>
                            </div>
                          </>
                        );
                      default:
                        return null;
                    }
                  })()}
                </div>

                <div className="propertyCharacteristics">
                  <h3>{t("features")}</h3>

                  <div className="propertyCharacteristicsInner">
                    <Row>
                      <Col xxl={4}>
                        <div className="propertyCharacteristicsSingleBox">
                          <div className="propertyCharacteristicsSingleBoxLeft">
                            <FontAwesomeIcon icon={faBuilding} />
                          </div>
                          <div className="propertyCharacteristicsSingleBoxRight">
                            <p>{t("project")}</p>
                            <h5>
                              {typeof property == "object" &&
                                property?.project != null
                                ? getenumbykey(parse(property.project), 'project')
                                : ""}
                            </h5>
                          </div>
                        </div>
                      </Col>

                      <Col xxl={4}>
                        <div className="propertyCharacteristicsSingleBox">
                          <div className="propertyCharacteristicsSingleBoxLeft">
                            <FontAwesomeIcon icon={faStar} />
                          </div>
                          <div className="propertyCharacteristicsSingleBoxRight">
                            <p>{t("class")}</p>
                            <h5>
                              {typeof property == "object" &&
                                property?.class != null
                                ? getenumbykey(parse(property.class), 'class')
                                : ""}
                            </h5>
                          </div>
                        </div>
                      </Col>

                      <Col xxl={4}>
                        <div className="propertyCharacteristicsSingleBox">
                          <div className="propertyCharacteristicsSingleBoxLeft">
                            <FontAwesomeIcon icon={faBuildingShield} />
                          </div>
                          <div className="propertyCharacteristicsSingleBoxRight">
                            <p>{t("condition")}</p>
                            <h5>
                              {typeof property == "object" &&
                                property?.condition != null
                                ? getenumbykey(parse(property.condition), 'condition')
                                : ""}
                            </h5>
                          </div>
                        </div>
                      </Col>

                      <Col xxl={4}>
                        <div className="propertyCharacteristicsSingleBox">
                          <div className="propertyCharacteristicsSingleBoxLeft">
                            <FontAwesomeIcon icon={faBuildingColumns} />
                          </div>
                          <div className="propertyCharacteristicsSingleBoxRight">
                            <p>{t("building_company")}</p>
                            <h5>
                              {typeof property == "object" &&
                                property?.building_company != null
                                ? property.building_company
                                : ""}
                            </h5>
                          </div>
                        </div>
                      </Col>

                      <Col xxl={4}>
                        <div className="propertyCharacteristicsSingleBox">
                          <div className="propertyCharacteristicsSingleBoxLeft">
                            <FontAwesomeIcon icon={faBuilding} />
                          </div>
                          <div className="propertyCharacteristicsSingleBoxRight">
                            <p>{t("build_date")}</p>
                            <h5>
                              {typeof property == "object" &&
                                property?.build_date != null
                                ? getenumbykey(parse(property.build_date), 'build_date')
                                : ""}
                            </h5>
                          </div>
                        </div>
                      </Col>

                      {renderInfoBox(
                        "პროექტის ექსტერიერის სტილი",
                        hasValue(property?.property_project_exterrior_style)
                          ? optionLabel(
                            Options.propertyProjectExterriorStyleOptions,
                            property.property_project_exterrior_style,
                          )
                          : null,
                      )}

                      {renderInfoBox(
                        "პროექტის ინტერიერის სტილი",
                        hasValue(property?.property_project_style)
                          ? optionLabel(
                            Options.propertyProjectInteriorStyleOptions,
                            property.property_project_style,
                          )
                          : null,
                      )}

                      {property?.property_status == "new" ||
                        property?.property_status == "underconstruction" ? (
                        <>
                          <Col xxl={4}>
                            <div className="propertyCharacteristicsSingleBox">
                              <div className="propertyCharacteristicsSingleBoxLeft">
                                <FontAwesomeIcon icon={faCalendarDays} />
                              </div>
                              <div className="propertyCharacteristicsSingleBoxRight">
                                <p>{t("start_end_date")}</p>
                                <h5>
                                  {typeof property == "object" &&
                                    property?.start_date != null
                                    ? property.start_date
                                    : ""}
                                  &nbsp;-&nbsp;
                                  {typeof property == "object" &&
                                    property?.end_date != null
                                    ? property.end_date
                                    : ""}
                                </h5>
                              </div>
                            </div>
                          </Col>

                          {property?.finished_project == "yes" ? (
                            <div className="mainParamBox mt-3 mb-4">
                              <div className="paramIcon">
                                <FontAwesomeIcon icon={faCheckSquare} />
                              </div>
                              <div className="paramText">
                                <h5>დასრულებული პროექტი</h5>
                                <p>
                                  <strong>კი</strong>
                                </p>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}

                      {[
                        property?.cadaster_1,
                        property?.cadaster_2,
                        property?.cadaster_3,
                        property?.cadaster_4,
                        property?.cadaster_5,
                      ].map((item) => {
                        return item != null ? (
                          <Col xxl={4}>
                            <div className="propertyCharacteristicsSingleBox">
                              <div className="propertyCharacteristicsSingleBoxLeft">
                                <FontAwesomeIcon icon={faHashtag} />
                              </div>
                              <div className="propertyCharacteristicsSingleBoxRight">
                                <p>{t("cadaster")}</p>
                                <h5>{item}</h5>
                              </div>
                            </div>
                          </Col>
                        ) : null;
                      })}

                      {property?.disabledaccessible == "yes" ? (
                        <div className="mainParamBox">
                          <div className="paramIcon">
                            <FontAwesomeIcon icon={faCheckSquare} />
                          </div>
                          <div className="paramText">
                            <h5>შშმ ადაპტირებული</h5>
                            <p>
                              <strong>კი</strong>
                            </p>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </Row>
                  </div>
                </div>

                <div className="propertyCharacteristics">
                  <h3>პროექტის დეტალები</h3>
                  <div className="propertyCharacteristicsInner">
                    <Container className="p-0">
                      <Row>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>ბლოკის რაოდენობა</p>
                              <h5>
                                {property?.block_amount != null
                                  ? property.block_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>კერძო სახლი, ვილის რაოდენობა</p>
                              <h5>
                                {property?.villa_amount != null
                                  ? property.villa_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მიწის ფართი</p>
                              <h5>
                                {property?.land_size != null
                                  ? property.land_size
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>აპარტამენტების რაოდენობა</p>
                              <h5>
                                {property?.apartment_amount != null
                                  ? property.apartment_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>სტუდიოს რაოდენობა</p>
                              <h5>
                                {property?.studio_amount != null
                                  ? property.studio_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>1 საძინებლიანის რაოდენობა</p>
                              <h5>
                                {property?.one_bedroom_amount != null
                                  ? property.one_bedroom_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>2 საძინებლიანის რაოდენობა</p>
                              <h5>
                                {property?.two_bedroom_amount != null
                                  ? property.two_bedroom_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>3 საძინებლიანის რაოდენობა</p>
                              <h5>
                                {property?.three_bedroom_amount != null
                                  ? property.three_bedroom_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>4 საძინებლიანის რაოდენობა</p>
                              <h5>
                                {property?.four_bedroom_amount != null
                                  ? property.four_bedroom_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>5 საძინებლიანის რაოდენობა</p>
                              <h5>
                                {property?.five_bedroom_amount != null
                                  ? property.five_bedroom_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>5 + საძინებლიანის რაოდენობა</p>
                              <h5>
                                {property?.fiveplus_bedroom_amount != null
                                  ? property.fiveplus_bedroom_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>დუპლექსის რაოდენობა</p>
                              <h5>
                                {property?.duplex_amount != null
                                  ? property.duplex_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>ტერასიანი ბინების რაოდენობა</p>
                              <h5>
                                {property?.terrace_amount != null
                                  ? property.terrace_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>პარკინგის რაოდენობა</p>
                              <h5>
                                {property?.parking_amount != null
                                  ? property.parking_amount
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>ბინები სართულზე (მინ)</p>
                              <h5>
                                {property?.floorrooms_amount_min != null
                                  ? property.floorrooms_amount_min
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>ბინები სართულზე (მაქს)</p>
                              <h5>
                                {property?.floorrooms_amount_max != null
                                  ? property.floorrooms_amount_max
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მინიმალური ფართი</p>
                              <h5>
                                {property?.floorrooms_min_area != null
                                  ? property.floorrooms_min_area
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მაქსიმალური ფართი</p>
                              <h5>
                                {property?.floorrooms_max_area != null
                                  ? property.floorrooms_max_area
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მინიმალური ფასი GEL</p>
                              <h5>
                                {property?.floorrooms_min_price_gel != null
                                  ? property.floorrooms_min_price_gel
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მინიმალური ფასი USD</p>
                              <h5>
                                {property?.floorrooms_min_price_usd != null
                                  ? property.floorrooms_min_price_usd
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მინიმალური ფასი EUR</p>
                              <h5>
                                {property?.floorrooms_min_price_eur != null
                                  ? property.floorrooms_min_price_eur
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მაქსიმალური ფასი GEL</p>
                              <h5>
                                {property?.floorrooms_max_price_gel != null
                                  ? property.floorrooms_max_price_gel
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მაქსიმალური ფასი USD</p>
                              <h5>
                                {property?.floorrooms_max_price_usd != null
                                  ? property.floorrooms_max_price_usd
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მაქსიმალური ფასი EUR</p>
                              <h5>
                                {property?.floorrooms_max_price_eur != null
                                  ? property.floorrooms_max_price_eur
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>კომერციული ფართის რაოდენობა</p>
                              <h5>
                                {property?.commercial_area_count != null
                                  ? property.commercial_area_count
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>საოფისე ფართის რაოდენობა</p>
                              <h5>
                                {property?.office_area_count != null
                                  ? property.office_area_count
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>უპრ. განვადების თვეების რაოდენობა</p>
                              <h5>
                                {property?.installment_months != null
                                  ? property.installment_months
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მინიმალური შესატანი პროცენტი</p>
                              <h5>
                                {property?.minimal_percent != null
                                  ? property.minimal_percent
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>ამონაგები პროცენტი (ROI)</p>
                              <h5>
                                {property?.roi_percent != null
                                  ? property.roi_percent
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        {[
                          ["ყოველთვიური შესატანი მინიმალური თანხა GEL", "home_max_price_gel"],
                          ["ყოველთვიური შესატანი მინიმალური თანხა USD", "home_max_price_usd"],
                          ["ყოველთვიური შესატანი მინიმალური თანხა EUR", "home_max_price_eur"],
                          ["კომერციული ფართის ფართი (მინ)", "commercial_area_min"],
                          ["კომერციული ფართის ფართი (მაქს)", "commercial_area_max"],
                          ["კომერციული ფართის მინიმალური ფასი GEL", "commercial_min_price_gel"],
                          ["კომერციული ფართის მინიმალური ფასი USD", "commercial_min_price_usd"],
                          ["კომერციული ფართის მინიმალური ფასი EUR", "commercial_min_price_eur"],
                          ["კომერციული ფართის მაქსიმალური ფასი GEL", "commercial_max_price_gel"],
                          ["კომერციული ფართის მაქსიმალური ფასი USD", "commercial_max_price_usd"],
                          ["კომერციული ფართის მაქსიმალური ფასი EUR", "commercial_max_price_eur"],
                          ["საოფისე ფართის ფართი (მინ)", "office_area_min"],
                          ["საოფისე ფართის ფართი (მაქს)", "office_area_max"],
                          ["საოფისე ფართის მინიმალური ფასი GEL", "office_min_price_gel"],
                          ["საოფისე ფართის მინიმალური ფასი USD", "office_min_price_usd"],
                          ["საოფისე ფართის მინიმალური ფასი EUR", "office_min_price_eur"],
                          ["საოფისე ფართის მაქსიმალური ფასი GEL", "office_max_price_gel"],
                          ["საოფისე ფართის მაქსიმალური ფასი USD", "office_max_price_usd"],
                          ["საოფისე ფართის მაქსიმალური ფასი EUR", "office_max_price_eur"],
                          ["უპრ. განვადების თვეების რაოდენობა (საოფისე)", "house_installment_months"],
                          ["მინიმალური შესატანი პროცენტი (საოფისე)", "house_minimal_percent"],
                          ["პარკინგის მინიმალური ფასი", "parking_min_price"],
                          ["პარკინგის მაქსიმალური ფასი", "parking_max_price"],
                          ["0 სართულზე პარკინგის რაოდენობა", "parking_floor_null_amount"],
                          ["0 სართულზე პარკინგის ფართი", "parking_floor_null_area"],
                          ["-1 სართულზე პარკინგის რაოდენობა", "parking_floor_minus_1_amount"],
                          ["-1 სართულზე პარკინგის ფართი", "parking_floor_minus_1_area"],
                          ["-2 სართულზე პარკინგის რაოდენობა", "parking_floor_minus_2_amount"],
                          ["-2 სართულზე პარკინგის ფართი", "parking_floor_minus_2_area"],
                          ["-3 სართულზე პარკინგის რაოდენობა", "parking_floor_minus_3_amount"],
                          ["-3 სართულზე პარკინგის ფართი", "parking_floor_minus_3_area"],
                          ["-4 სართულზე პარკინგის რაოდენობა", "parking_floor_minus_4_amount"],
                          ["-4 სართულზე პარკინგის ფართი", "parking_floor_minus_4_area"],
                        ].map(([label, field]) =>
                          renderInfoBox(label, property?.[field]),
                        )}

                        <div className="devider"></div>

                        {property?.financed_by_bank == "yes" ? (
                          <Col xxl={6} className="mb-3">
                            <div className="mainParamBox">
                              <div className="paramIcon">
                                <FontAwesomeIcon icon={faCheckSquare} />
                              </div>
                              <div className="paramText">
                                <h5>დაფინანსებულია ბანკის მიერ</h5>
                                <p>
                                  <strong>კი</strong>
                                </p>
                              </div>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}

                        {property?.investment_apartments == "yes" ? (
                          <Col xxl={6} className="mb-3">
                            <div className="mainParamBox">
                              <div className="paramIcon">
                                <FontAwesomeIcon icon={faCheckSquare} />
                              </div>
                              <div className="paramText">
                                <h5>საინვესტიციო ბინები</h5>
                                <p>
                                  <strong>კი</strong>
                                </p>
                              </div>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}

                        {property?.residential_apartments == "yes" ? (
                          <Col xxl={6} className="mb-3">
                            <div className="mainParamBox">
                              <div className="paramIcon">
                                <FontAwesomeIcon icon={faCheckSquare} />
                              </div>
                              <div className="paramText">
                                <h5>საცხოვრებელი ბინები</h5>
                                <p>
                                  <strong>კი</strong>
                                </p>
                              </div>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}

                        {property?.complete_renovation == "yes" ? (
                          <Col xxl={6} className="mb-3">
                            <div className="mainParamBox">
                              <div className="paramIcon">
                                <FontAwesomeIcon icon={faCheckSquare} />
                              </div>
                              <div className="paramText">
                                <h5>ბინები სრული რემონტით</h5>
                                <p>
                                  <strong>კი</strong>
                                </p>
                              </div>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}

                        {property?.five_star_hotel_standard == "yes" ? (
                          <Col xxl={6} className="mb-3">
                            <div className="mainParamBox">
                              <div className="paramIcon">
                                <FontAwesomeIcon icon={faCheckSquare} />
                              </div>
                              <div className="paramText">
                                <h5>5 ვარკვლავიანი სასტუმროს სტანდარტით</h5>
                                <p>
                                  <strong>კი</strong>
                                </p>
                              </div>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}

                        {property?.property_management_service == "yes" ? (
                          <Col xxl={6} className="mb-3">
                            <div className="mainParamBox">
                              <div className="paramIcon">
                                <FontAwesomeIcon icon={faCheckSquare} />
                              </div>
                              <div className="paramText">
                                <h5>ქონების მართვის სერვისი</h5>
                                <p>
                                  <strong>კი</strong>
                                </p>
                              </div>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}

                        {property?.customized_payment == "yes" ? (
                          <Col xxl={6} className="mb-3">
                            {renderParamBox(
                              "customized_payment",
                              "გადახდის მორგებული გრაფიკი",
                            )}
                          </Col>
                        ) : (
                          ""
                        )}
                      </Row>
                    </Container>
                  </div>
                </div>

                <div className="propertyDescription">
                  <h3>{t("description")}</h3>
                  <p>
                    {showFullText
                      ? property?.translations?.[0]?.text
                      : property?.translations?.[0]?.text?.slice(0, 142)}
                    {property?.translations?.[0]?.text?.length > 150 && (
                      <div className="showMoreText" onClick={toggleText}>
                        {showFullText ? "დამალვა" : "მეტის ნახვა"}
                      </div>
                    )}
                  </p>
                </div>

                <div className="propertyDetails">
                  <div className="propertyCharacteristics">
                    <h3>დეტალები</h3>
                    <div className="propertyCharacteristicsInner">
                      <Row>
                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>სრული ფართი</p>
                              <h5>
                                {property?.area != null ? property.area : ""} მ
                                <sup>2</sup>
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>ოთახების რაოდენობა</p>
                              <h5>
                                {property?.rooms != null ? property.rooms : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>საძინებლების რაოდენობა</p>
                              <h5>
                                {property?.bedrooms != null
                                  ? property.bedrooms
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>მასტერ საძინებლების რ.ბა</p>
                              <h5>
                                {property?.masterbedrooms != null
                                  ? property.masterbedrooms
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>სართული</p>
                              <h5>
                                {property?.floor != null ? property.floor : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>სართული სულ</p>
                              <h5>
                                {property?.allfloor != null
                                  ? property.allfloor
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>სველი წერტილების რ.ბა</p>
                              <h5>
                                {property?.bathrooms != null
                                  ? property.bathrooms
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4}>
                          <div className="propertyCharacteristicsSingleBox">
                            <div className="propertyCharacteristicsSingleBoxLeft">
                              <FontAwesomeIcon icon={faBuilding} />
                            </div>
                            <div className="propertyCharacteristicsSingleBoxRight">
                              <p>ჭერის სიმაღლე (სმ)</p>
                              <h5>
                                {property?.ceilingHeight != null
                                  ? property.ceilingHeight
                                  : ""}
                              </h5>
                            </div>
                          </div>
                        </Col>

                        {renderInfoBox(
                          "მიწის ნაკვეთის ფართი",
                          property?.land_area,
                          <> მ<sup>2</sup></>,
                        )}
                        {renderInfoBox("სადარბაზოს N", property?.entranceNumber)}
                        {renderInfoBox("სადარბაზოს რაოდ.", property?.entranceCount)}
                      </Row>
                    </div>
                  </div>

                  <div className="detailsCardBox">
                    <Row>
                      <Col xxl={12}>
                        <div className="propertyDetailsProp">
                          <h3>კომუნიკაციები</h3>

                          <div className="propertyDetailsPropBox">
                            {property?.communications ? (
                              <div className="propertyDetailsInner">
                                <Row>
                                  {property?.communications?.includes(
                                    "electricity",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>დენი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.communications?.includes(
                                    "water",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>წყალი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.communications?.includes("gas") ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>გაზი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.communications?.includes(
                                    "sewercollector",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>კოლექტორი-კანალიზაცია</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.communications?.includes(
                                    "individualurikanalizacia",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ინდივიდუალური კანალიზაცია</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.communications?.includes(
                                    "owntransformer",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>საკუთარი ტრანსფორმატორი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {renderGroupItems("communications", [
                                    ["lightnearland", "დენი ახლოს"],
                                    ["waternearland", "წყალი ახლოს"],
                                    ["gasnearland", "გაზი ახლოს"],
                                    ["sewernearland", "კოლექტორი-კანალიზაცია ახლოს"],
                                  ])}
                                </Row>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="detailsCardBox">
                    <Row>
                      <Col xxl={12}>
                        <div className="propertyDetailsProp">
                          <h3>ზოგადი დეტალები</h3>

                          <div className="propertyDetailsPropBox">
                            {property?.additionaldetails ? (
                              <div className="propertyDetailsInner">
                                <Row>
                                  {property?.additionaldetails?.includes(
                                    "firstrow",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>პირველი ზოლი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "secondrow",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>მეორე ზოლი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "thirdrow",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>მესამე ზოლი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "easement",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სერვიტუტი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "magalidzabva",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>მაღალი ძაბვა</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "capitalfence",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>კაპიტალური ღობე</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "rkinigzischixi",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>რკინიგზის ჩიხი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "mdinarispiri",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>მდინარისპირი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "bunebriviresursebi",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ბუნებრივი რესურსები</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "well",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ჭა</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "sarwyavi",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სარწყავი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "urwyavi",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ურწყავი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "fence",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ღობე</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "pumpsystem",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სატუმბი სისტემა</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "borehole",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ჭაბურღილი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}

                                  {property?.additionaldetails?.includes(
                                    "dripirrigationsystem",
                                  ) ? (
                                    <Col xxl={4}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>წვეთოვანი სარწყავი სისტემა</h5>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : (
                                    ""
                                  )}
                                </Row>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="detailsCardBox">
                    <Row>
                      <Col xxl={12}>
                        <div className="propertyDetailsProp">
                          <h3>პარამეტრები</h3>

                          <div className="propertyDetailsPropBox">
                            {property?.duplex == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>დუპლექსი</h5>
                                  <p>
                                    <strong>კი</strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.triplex == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ტრიპლექსი</h5>
                                  <p>
                                    <strong>კი</strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.livingroom == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>მისაღები</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.livingspace != null
                                        ? property.livingspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.livingamount != null
                                        ? property.livingamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.studio == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>სტუდიო</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.studiospace != null
                                        ? property.studiospace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.kitchen == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>სამზარეულო</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.kitchenspace != null
                                        ? property.kitchenspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.kitchenamount != null
                                        ? property.kitchenamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.cabinet == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>კაბინეტის ოთახი</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.cabinetspace != null
                                        ? property.cabinetspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.cabinetamount != null
                                        ? property.cabinetamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.childrenroom == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>საბავშვო ოთახი</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.childrenroomspace != null
                                        ? property.childrenroomspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.childrenroomamount != null
                                        ? property.childrenroomamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.openbalcony == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ღია აივანი</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.openbalconyspace != null
                                        ? property.openbalconyspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.openbalconyamount != null
                                        ? property.openbalconyamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.closedbalcony == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>დახურული აივანი</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.closedbalconyspace != null
                                        ? property.closedbalconyspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.closedbalconyamount != null
                                        ? property.closedbalconyamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.frenchbalcony == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ფრანგული აივანი</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.frenchbalconyspace != null
                                        ? property.frenchbalconyspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.frenchbalconyamount != null
                                        ? property.frenchbalconyamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.terrace == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ვერანდა/ტერასა</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.terracespace != null
                                        ? property.terracespace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.terraceamount != null
                                        ? property.terraceamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.dressingroom == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>საგარდერობო ოთახი</h5>
                                  <h6>
                                    ფართი კვ.მ:
                                    <strong>
                                      {property?.dressingroomspace != null
                                        ? property.dressingroomspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.dressingroomamount != null
                                        ? property.dressingroomamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.storage == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>სათავსო</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.storagespace != null
                                        ? property.storagespace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.storageamount != null
                                        ? property.storageamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.summerkitchen == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>საზაფხულო სამზარეულო</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.summerkitchenspace != null
                                        ? property.summerkitchenspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.fireplaceroom == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ბუხრის ოთახი</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.fireplaceroomspace != null
                                        ? property.fireplaceroomspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.basement == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>სარდაფი</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.basementspace != null
                                        ? property.basementspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.basementamount != null
                                        ? property.basementamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.loggia == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ლოჯი</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.loggiaspace != null
                                        ? property.loggiaspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.hall == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ჰოლი</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.hallspace != null
                                        ? property.hallspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.loft == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>სხვენი</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.loftspace != null
                                        ? property.loftspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.mansarda == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>მანსარდა</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.mansardaspace != null
                                        ? property.mansardaspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.buildup == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>დაშენება</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.buildupspace != null
                                        ? property.buildupspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.buildup1 == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>მიშენება</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.buildupspace1 != null
                                        ? property.buildupspace1
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.commoncorridor == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>საერთო კორიდორი</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.commoncorridorspace != null
                                        ? property.commoncorridorspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.antresor == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ანტრესორი</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.antresorspace != null
                                        ? property.antresorspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.wintergarden == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ზამთრის ბაღი</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.wintergardenspace != null
                                        ? property.wintergardenspace
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {renderParamBox("garage", "ავტოფარეხი", {
                              space: "garage_area",
                              amount: "garageamount",
                            })}

                            {renderParamBox("yardparking", "ეზოს პარკინგი", {
                              space: "yardparking_area",
                              amount: "yardparkingamount",
                            })}

                            {renderParamBox(
                              "undergroundparking",
                              "მიწისქვეშა პარკინგი",
                              {
                                space: "undergroundparking_area",
                                amount: "undergroundparkingamount",
                              },
                            )}

                            {renderParamBox("parkingspace", "პარკინგის ადგილი", {
                              space: "parkingspace_area",
                              amount: "parkingspaceamount",
                            })}

                            {property?.paidparking == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ფასიანი პარკინგი</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.paidparkingamount != null
                                        ? property.paidparkingamount
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {renderParamBox("house_amount", "სახლის რაოდენობა", {
                              space: "house_amount_space",
                              amount: "house_amount_sum",
                            })}
                            {renderParamBox("aux_building", "დამხმარე შენობა", {
                              space: "aux_building_space",
                              amount: "aux_building_sum",
                            })}
                            {renderParamBox("quadruplex", "ქუადპლექსი")}
                            {renderParamBox("beletazh", "ბელეტაჟი")}
                            {renderParamBox("inside_area", "შიდა ფართი", {
                              space: "inside_area_space",
                            })}
                            {renderParamBox(
                              "livingroom_kitchen",
                              "მისაღები + სასადილო ოთახი",
                              {
                                space: "livingroom_kitchen_amount",
                                amount: "livingroom_kitchen_quantity",
                              },
                            )}
                            {renderParamBox(
                              "kitchen_dining",
                              "სამზარეულო + სასადილო ოთახი",
                              {
                                space: "kitchen_dining_amount",
                                amount: "kitchen_dining_quantity",
                              },
                            )}
                            {renderParamBox("dining_room", "სასადილო ოთახი", {
                              space: "dining_room_amount",
                              amount: "dining_room_quantity",
                            })}
                            {renderParamBox("balconyall", "აივანების რაოდენობა", {
                              space: "balconyallspace",
                              amount: "balconyallamount",
                            })}
                            {renderParamBox(
                              "closed_terrace",
                              "დახურული ვერანდა/ტერასა",
                              {
                                space: "closed_terrace_space",
                                amount: "closed_terrace_amount",
                              },
                            )}
                            {renderParamBox("glassware", "შუშაბანდი", {
                              space: "glasswaresource",
                              amount: "glasswareamount",
                            })}
                            {renderParamBox("partyroom", "საქეიფო ოთახი", {
                              space: "partyroomspace",
                            })}
                            {renderParamBox("technical_room", "ტექნიკური ოთახი", {
                              space: "technical_room_area",
                            })}
                            {renderParamBox("laundry_room", "სამრეცხაო ოთახი", {
                              space: "laundry_room_area",
                            })}
                            {renderParamBox("wineroom", "მარანის ოთახი", {
                              space: "wineroomspace",
                            })}
                            {renderParamBox("refrigerator_room", "სამაცივრე ოთახი", {
                              space: "refrigerator_room_space",
                            })}
                            {renderParamBox("gym_room", "ტრენაჟორების ოთახი", {
                              space: "gym_room_space",
                            })}
                            {renderParamBox("billiard_room", "საბილიარდო ოთახი", {
                              space: "billiard_room_space",
                            })}
                            {renderParamBox("cinema_room", "კინოს ოთახი", {
                              space: "cinema_room_space",
                            })}
                            {renderParamBox("common_kitchen", "საერთო სამზარეულო", {
                              space: "common_kitchen_area",
                            })}
                            {renderParamBox("common_storage", "საერთო სათავსო", {
                              space: "common_storage_area",
                            })}
                            {renderParamBox("common_terrace", "საერთო ტერასა", {
                              space: "common_terrace_area",
                            })}
                            {renderParamBox("common_attic", "საერთო სხვენი", {
                              space: "common_attic_area",
                            })}
                            {renderParamBox("outdoor_wc", "გარე სველი წერტილი")}
                            {renderParamBox("isolated", "იზოლირებული სველი წერტილი")}

                            {property?.commonbathroom == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>საერთო სველი წერტილი</h5>
                                  <p>
                                    <strong>კი</strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.yeard == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>კერძო ეზო</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.yeardarea != null
                                        ? property.yeardarea
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.common_yard == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>საერთო ეზო</h5>
                                  <h6>
                                    ფართი კვ.მ
                                    <strong>
                                      {property?.common_yard_area != null
                                        ? property.common_yard_area
                                        : ""}
                                      მ<sup>2</sup>
                                    </strong>
                                  </h6>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* Hidden details start */}

                  {/* კერძო სახლი / თაუნჰაუსი */}
                  {property?.property_type == "house" ||
                    property?.property_type == "cottage" ||
                    property?.property_type == "townhouse" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>
                              კერძო სახლი, ვილა, აგარაკი, კოტეჯი, თაუნ ჰაუსის
                              დეტალები
                            </h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.fence == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ღობე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.vine == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ვაზი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.fruit == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხეხილი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.citrus == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ციტრუსი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.leafy == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ფოთლოვანი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.coniferous == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>წიწვოვანი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.goodrelief == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კარგი რელიეფი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.relieful_land == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>რელიეფური მიწა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.highland_status == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მაღალმთიანი მიწის სტატუსი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {[
                                  ["capitalfence", "კაპიტალური ღობე"],
                                  ["non_rural", "არასასოფლო მიწა"],
                                  ["rural", "სასოფლო მიწა"],
                                  ["flowering", "ყვავილოვანი მცენარე"],
                                  ["perennial", "მრავალწლოვანი მცენარე"],
                                  ["shrubs_grasses", "ბუჩქები, ბალახოვანი მცენარე"],
                                  ["decorative", "დეკორატიული მცენარე"],
                                  ["palm", "პალმა"],
                                  ["nut", "კაკალი/თხილი"],
                                  ["tea", "ჩაი"],
                                  ["eucalyptus", "ევკალიპტი"],
                                  ["bamboo", "ბამბუკი"],
                                  ["greenhouse", "სათბური"],
                                  ["irrigation_system", "სარწყავი სისტემა"],
                                  ["shared_wet_area", "საერთო სველი წერტილი"],
                                  ["external_wet_area", "გარე სველი წერტილი"],
                                ].map(([field, label]) =>
                                  renderListCheck(field, label),
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* კომერციული / საოფისე ფართი */}
                  {property?.property_type == "comercialoffice" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>კომერციული / საოფისე ფართის დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                <Col xxl={12}>
                                  <div className="mainParamBox mb-32">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>ფართის ტიპი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.typeofspace != null
                                          ? getenumbykey(
                                            parse(property.typeofspace), 'typeofspace',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {property?.showcase == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>ვიტრინა</h5>
                                        <h6>
                                          რაოდენობა:{" "}
                                          <strong>
                                            {property?.showcaseamount != null
                                              ? property.showcaseamount
                                              : ""}
                                          </strong>
                                        </h6>
                                        <p>
                                          სიგრძე (სმ):{" "}
                                          <strong>
                                            {property?.showcaselength != null
                                              ? property.showcaselength
                                              : ""}
                                          </strong>
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>ფასადი</h5>
                                        <h6>
                                          სიგრძე (სმ):{" "}
                                          <strong>
                                            {property?.facadelength != null
                                              ? property.facadelength
                                              : ""}
                                          </strong>
                                        </h6>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade == "hall2" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>დარბაზი</h5>
                                        <h6>
                                          რაოდენობა:{" "}
                                          <strong>
                                            {property?.hall2amount != null
                                              ? property.hall2amount
                                              : ""}
                                          </strong>
                                        </h6>
                                        <p>
                                          ფართი კვ.მ:
                                          <strong>
                                            {property?.hall2area != null
                                              ? property.hall2area
                                              : ""}{" "}
                                            მ<sup>2</sup>
                                          </strong>
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.separatebuilding == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>ცალკე მთლიანი შენობა</h5>
                                        <p>
                                          <strong>კი</strong>
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.partofbuilding == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>შენობის ნაწილი</h5>
                                        <p>
                                          <strong>კი</strong>
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hall2 == "yes" ? (
                                  <Col xxl={12}>
                                    {renderParamBox("hall2", "დარბაზი", {
                                      space: "hall2area",
                                      amount: "hall2amount",
                                    })}
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.railroad == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>გზისპირი</h5>
                                        <p>
                                          <strong>კი</strong>
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* სასტუმრო */}
                  {property?.property_type == "hotel" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>სასტუმროს დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>სასტუმროს ტიპი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.property_type != null
                                          ? getenumbykey(
                                            parse(property.property_type), 'property_type',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>ვარსკვლავების რაოდენობა</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.numberofstars != null
                                          ? getenumbykey(
                                            parse(property.numberofstars), 'numberofstars',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>ნომრების რაოდენობა</h5>
                                      <h6>
                                        {property?.roomamount != null
                                          ? property.roomamount
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12} className="mb-3">
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>ლუქსების რაოდენობა</h5>
                                      <h6>
                                        {property?.luxamount != null
                                          ? property.luxamount
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {property?.glamping == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>გლემფინგი</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.glampingamount != null
                                            ? property.glampingamount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.familyhotel == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>საოჯახო სასტუმრო</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hostel == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>ჰოსტელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_cottage == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>სასტუმროს ტიპის კოტეჯი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_apartment == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>სასტუმროს ტიპის აპარტამენტი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_sgl == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>SGL</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_sgl_amount !=
                                            null
                                            ? property.hotel_type_sgl_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_dbl == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>DBL</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_dbl_amount !=
                                            null
                                            ? property.hotel_type_dbl_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_twin == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>TWIN</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_twin_amount !=
                                            null
                                            ? property.hotel_type_twin_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_trpl == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>TRPL</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_trpl_amount !=
                                            null
                                            ? property.hotel_type_trpl_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_quad == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>Quad</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_quad_amount !=
                                            null
                                            ? property.hotel_type_quad_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_extra_bed == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>Extra Bed</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_extra_bed_amount !=
                                            null
                                            ? property.hotel_type_extra_bed_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_queen == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>Queen</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_queen_amount !=
                                            null
                                            ? property.hotel_type_queen_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_king == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>King</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_king_amount !=
                                            null
                                            ? property.hotel_type_king_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_studio == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>Studio</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_studio_amount !=
                                            null
                                            ? property.hotel_type_studio_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_connecting_room ==
                                  "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>Connecting room</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_connecting_room_amount !=
                                            null
                                            ? property.hotel_type_connecting_room_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_adjoining_room ==
                                  "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>Adjoining room</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_adjoining_room_amount !=
                                            null
                                            ? property.hotel_type_adjoining_room_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_duplex == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>Duplex</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_duplex_amount !=
                                            null
                                            ? property.hotel_type_duplex_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_family_room == "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>Family room</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_family_room_amount !=
                                            null
                                            ? property.hotel_type_family_room_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {property?.hotel_type_accessible_room ==
                                  "yes" ? (
                                  <div className="mainParamBox">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faCheckSquare} />
                                    </div>
                                    <div className="paramText">
                                      <h5>Accessible Room / Disabled Room</h5>
                                      <p>
                                        რაოდენობა:
                                        <strong>
                                          {property?.hotel_type_accessible_room_amount !=
                                            null
                                            ? property.hotel_type_accessible_room_amount
                                            : ""}
                                        </strong>
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>კვება</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.food != null
                                          ? getenumbykey(parse(property.food), 'food')
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>აქტივობა</h5>
                                      <h6>
                                        {property?.activity != null
                                          ? property.activity
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {[
                                  ["boat", "კატერი", "boatamount"],
                                  ["scooter", "სკუტერი", "scooteramount"],
                                  ["quadrocycle", "კვადროციკლი", "quadrocycleamount"],
                                  ["horses", "ცხენები", "horsesamount"],
                                ].map(([field, label, amount]) =>
                                  property?.[field] == "yes" ? (
                                    <Col xxl={6} key={field}>
                                      {renderParamBox(field, label, { amount })}
                                    </Col>
                                  ) : null,
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* ბიზნესცენტრი */}
                  {property?.property_type == "businesscenter" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ბიზნესცენტრის დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>ბიზნესცენტრის კლასი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.businesscenterclass != null
                                          ? getenumbykey(
                                            parse(
                                              property.businesscenterclass,
                                            ),
                                            'businesscenterclass',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {property?.bcseparatebuilding == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>ცალკე მთლიანი შენობა</h5>
                                        <p>
                                          <strong>კი</strong>
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.bcpartmentroom == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>შენობის ნაწილი</h5>
                                        <p>
                                          <strong>კი</strong>
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* მიწა */}
                  {property?.property_type == "land" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>მიწის დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>მიწის ტიპი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.landtype != null
                                          ? getenumbykey(
                                            parse(property.landtype), 'landtype',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-32">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>სას. სამეურნეო მიწის ტიპი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.agriculturalland != null
                                          ? getenumbykey(
                                            parse(property.agriculturalland), 'agriculturalland',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-32">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>არასასოფლო სამ. მიწის ტიპი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.agriculturalland2 != null
                                          ? getenumbykey(
                                            parse(property.agriculturalland2), 'agriculturalland2',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>ფუნქციური ზონა</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.functionalarea != null
                                          ? getenumbykey(
                                            parse(property.functionalarea), 'functionalarea',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {property?.building == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>შენობა ნაგებობა</h5>
                                        {hasValue(property?.buildingarea_amount) ? (
                                          <h6>
                                            რაოდენობა:{" "}
                                            <strong>{property.buildingarea_amount}</strong>
                                          </h6>
                                        ) : (
                                          ""
                                        )}
                                        <h6>
                                          სრული ფართი კვ.მ
                                          <strong>
                                            {property?.buildingarea != null
                                              ? property.buildingarea
                                              : ""}{" "}
                                            მ<sup>2</sup>
                                          </strong>
                                        </h6>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.apz == "yes" ? (
                                  <Col xxl={3}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>APZ</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.grg == "yes" ? (
                                  <Col xxl={3}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>GRG</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.agreedproject == "yes" ? (
                                  <Col xxl={3}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>შეთანხმებული პროექტი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.buildingpermission == "yes" ? (
                                  <Col xxl={3}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>მშენებლობის ნებართვა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.goodrelief == "yes" ? (
                                  <Col xxl={3}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>კარგი რელიეფი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.relieful_land == "yes" ? (
                                  <Col xxl={3}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>რელიეფური მიწა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.highland_status == "yes" ? (
                                  <Col xxl={3}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>მაღალმთიანი მიწის სტატუსი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* ბიზნეს ინვესტიცა */}
                  {property?.property_type == "business" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ბიზნეს ინვესტიციის დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>ბიზნეს ინვესტიციის კატეგორია</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.businessinvestmentcategory !=
                                          null
                                          ? getenumbykey(
                                            parse(
                                              property.businessinvestmentcategory,
                                            ),
                                            'businessinvestmentcategory',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>სხვა ინდუსტრია</h5>
                                      <h6>
                                        {property?.otherindustry != null
                                          ? property.otherindustry
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>მესაკუთრე</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.owner != null
                                          ? getenumbykey(parse(property.owner), 'owner')
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>საიდენტიფიკაციო კოდი</h5>
                                      <h6>
                                        {property?.Identificationcode != null
                                          ? property.Identificationcode
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {property?.building1 == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>შენობა ნაგებობა</h5>
                                        <h6>
                                          რაოდენობა:{" "}
                                          <strong>
                                            {property?.buildingamount1 != null
                                              ? property.buildingamount1
                                              : ""}
                                          </strong>
                                        </h6>
                                        <h6>
                                          სრული ფართი კვ.მ
                                          <strong>
                                            {property?.buildingarea1 != null
                                              ? property.buildingarea1
                                              : ""}{" "}
                                            მ<sup>2</sup>
                                          </strong>
                                        </h6>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>საკუთრების ტიპი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.propertytype != null
                                          ? getenumbykey(
                                            parse(property.propertytype), 'propertytype',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>მიწის ფართი</h5>
                                      <h6>
                                        <strong>
                                          {property?.landarea != null
                                            ? property.landarea
                                            : ""}{" "}
                                          მ<sup>2</sup>
                                        </strong>
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>თანამშრომლების რაოდენობა</h5>
                                      <h6>
                                        <strong>
                                          {property?.numberofemployees != null
                                            ? property.numberofemployees
                                            : ""}
                                        </strong>
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {typeof property == "object" &&
                                  property?.assets == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-32">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faBuilding} />
                                      </div>
                                      <div className="paramText">
                                        <h5>აქტივები</h5>
                                        <h6>
                                          <strong>კი</strong>
                                        </h6>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.heavyequipment == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainParamBox mb-32">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>მძიმე ტექნიკა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.specechnique == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainParamBox mb-32">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>სპეც ტექნიკა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.annualaccrual == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>წლიური დარიცხვა</h5>
                                        <h6>
                                          GEL:{" "}
                                          <strong>
                                            {property?.annualaccrualgel != null
                                              ? property.annualaccrualgel
                                              : ""}
                                          </strong>
                                        </h6>
                                        <h6>
                                          USD:{" "}
                                          <strong>
                                            {property?.annualaccrualusd != null
                                              ? property.annualaccrualusd
                                              : ""}
                                          </strong>
                                        </h6>
                                        <h6>
                                          RUB:{" "}
                                          <strong>
                                            {property?.annualaccrualeur != null
                                              ? property.annualaccrualeur
                                              : ""}
                                          </strong>
                                        </h6>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.annualnetprofit == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>წლიური წმინდა მოგება</h5>
                                        <h6>
                                          GEL:{" "}
                                          <strong>
                                            {property?.annualnetprofitgel !=
                                              null
                                              ? property.annualnetprofitgel
                                              : ""}
                                          </strong>
                                        </h6>
                                        <h6>
                                          USD:{" "}
                                          <strong>
                                            {property?.annualnetprofitusd !=
                                              null
                                              ? property.annualnetprofitusd
                                              : ""}
                                          </strong>
                                        </h6>
                                        <h6>
                                          RUB:{" "}
                                          <strong>
                                            {property?.annualnetprofiteur !=
                                              null
                                              ? property.annualnetprofiteur
                                              : ""}
                                          </strong>
                                        </h6>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* ფერმა */}
                  {property?.property_type == "farm" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ფერმის დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>ფერმის ტიპი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.farmtype != null
                                          ? getenumbykey(
                                            parse(property.farmtype), 'farmtype',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {typeof property == "object" &&
                                  property?.farmtype == "other" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faBuilding} />
                                      </div>
                                      <div className="paramText">
                                        <h5>სხვა ფერმის ტიპი</h5>
                                        <h6>
                                          {property?.otherfarmtype != null
                                            ? property.otherfarmtype
                                            : ""}
                                        </h6>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>მიწის ტიპი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.landtype1 != null
                                          ? getenumbykey(
                                            parse(property.landtype1), 'landtype1',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>სას. სამეურნეო მიწის ტიპი</h5>
                                      <h6>
                                        {typeof property == "object" &&
                                          property?.agrilandtype != null
                                          ? getenumbykey(
                                            parse(property.agrilandtype), 'agrilandtype',
                                          )
                                          : ""}
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {renderValueParam(
                                  "არასასოფლო სამეურნეო მიწის ტიპი",
                                  hasValue(property?.nonagrilandtype)
                                    ? optionLabel(
                                      Options.farmNonAgriculturalTypes,
                                      property.nonagrilandtype,
                                    )
                                    : null,
                                )}

                                {property?.lake == "yes" ? (
                                  <Col xxl={12}>
                                    {renderParamBox("lake", "ტბა", {
                                      space: "lakearea",
                                      amount: "lakeamount",
                                    })}
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.buildingstructureoffice == "yes" ? (
                                  <Col xxl={12}>
                                    <div className="mainParamBox mb-12">
                                      <div className="paramIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramText">
                                        <h5>შენობა ნაგებობა (ოფისი)</h5>
                                        <h6>
                                          რაოდენობა:{" "}
                                          <strong>
                                            {property?.buildingstructureofficeamount !=
                                              null
                                              ? property.buildingstructureofficeamount
                                              : ""}
                                          </strong>
                                        </h6>
                                        <h6>
                                          სრული ფართი კვ.მ
                                          <strong>
                                            {property?.buildingstructureofficearea !=
                                              null
                                              ? property.buildingstructureofficearea
                                              : ""}{" "}
                                            მ<sup>2</sup>
                                          </strong>
                                        </h6>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.goodrelief == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კარგი რელიეფი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.relieful_land == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>რელიეფური მიწა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.highland_status == "yes" ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მაღალმთიანი მიწის სტატუსი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* იყიდება განვადებით */}
                  {property?.transaction_type == "installment" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>განვადებით გაყიდვის დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {renderCurrencyParam(
                                  "წინასწარი შესატანი თანხა",
                                  "Initialdepositamount",
                                )}

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>წინასწარი შესატანი %</h5>
                                      <h6>
                                        <strong>
                                          {typeof property == "object" &&
                                            property?.Initialdepositamountpercent !=
                                            null
                                            ? property.Initialdepositamountpercent
                                            : ""}
                                        </strong>
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>ყოველთვიური %</h5>
                                      <h6>
                                        <strong>
                                          {typeof property == "object" &&
                                            property?.monthlydepositamountpercent !=
                                            null
                                            ? property.monthlydepositamountpercent
                                            : ""}
                                        </strong>
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>შიდა უპროცენტო განვადება (თვე)</h5>
                                      <h6>
                                        <strong>
                                          {typeof property == "object" &&
                                            property?.domestic_interest_free_installment !=
                                            null
                                            ? property.domestic_interest_free_installment
                                            : ""}
                                        </strong>
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {renderCurrencyParam(
                                  "ყოველთვიური შესატანი თანხა",
                                  "monthlydepositamount",
                                )}

                                {renderCurrencyParam(
                                  "თანხა ჯამში",
                                  "finalamounttotal",
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* ქირავდება დღიურად */}
                  {property?.transaction_type == "dailyrent" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>დღიურად გაქირავების დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>გაქირავების დაწყების დრო</h5>
                                      <h6>
                                        <strong>
                                          {typeof property == "object" &&
                                            property?.rentalstarttime != null
                                            ? property.rentalstarttime
                                            : ""}
                                        </strong>
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>გაქირავების დასრულების დრო</h5>
                                      <h6>
                                        <strong>
                                          {typeof property == "object" &&
                                            property?.rentalendtime != null
                                            ? property.rentalendtime
                                            : ""}
                                        </strong>
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {renderValueParam(
                                  "ზრდასრულების რაოდენობა (დან)",
                                  property?.adult_from,
                                )}

                                {renderValueParam(
                                  "ზრდასრულების რაოდენობა (მდე)",
                                  property?.adult_to,
                                )}

                                {renderValueParam(
                                  "ბავშვების რაოდენობა (დან)",
                                  property?.children_from,
                                )}

                                {renderValueParam(
                                  "ბავშვების რაოდენობა (მდე)",
                                  property?.children_to,
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* იყიდება აუქციონით */}
                  {property?.transaction_type == "auction" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>აუქციონით გაყიდვის დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                <Col xxl={12}>
                                  <div className="mainParamBox mb-12">
                                    <div className="paramIcon">
                                      <FontAwesomeIcon icon={faBuilding} />
                                    </div>
                                    <div className="paramText">
                                      <h5>აუქციონის დასრულების თარიღი</h5>
                                      <h6>
                                        <strong>
                                          {typeof property == "object" &&
                                            property?.auctiondeadline != null
                                            ? property.auctiondeadline
                                            : ""}
                                        </strong>
                                      </h6>
                                    </div>
                                  </div>
                                </Col>

                                {renderCurrencyParam(
                                  "მინიმალური შესატანი თანხა",
                                  "monthlydepositamount1",
                                )}

                                {renderCurrencyParam(
                                  "საგარანტიო თანხა",
                                  "finalamounttotal1",
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* მესაკუთრის ცხოვრების უფლებით გირავნობა */}
                  {property?.transaction_type == "pawnwithowner" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>მესაკუთრის ცხოვრების უფლებით გირავნობის დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {renderValueParam(
                                  "გირავნობის ვადა",
                                  property?.rentaldeadline,
                                )}

                                {renderCurrencyParam(
                                  "ყოველთვიური თანხა",
                                  "monthlyamount",
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* მოგირავნის ცხოვრების უფლებით იპოთეკა */}
                  {property?.transaction_type == "mortgage" ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>მოგირავნის ცხოვრების უფლებით იპოთეკის დეტალები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {renderValueParam(
                                  "იპოთეკის ვადა",
                                  property?.mortgagedeadline,
                                )}

                                {renderCurrencyParam(
                                  "ყოველთვიური თანხა",
                                  "mortgageamount",
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* Hidden details end */}

                  <div className="detailsCardBox">
                    <Row>
                      <Col xxl={12}>
                        <div className="propertyDetailsProp">
                          <h3>დამატებითი პარამეტრები</h3>

                          <div className="propertyDetailsPropBox">
                            {property?.elevator == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>სამგზავრო ლიფტი</h5>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.elevatoramount != null
                                        ? property.elevatoramount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.freightelevator == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>სატვირთო ლიფტი</h5>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.freightelevatoramount != null
                                        ? property.freightelevatoramount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {property?.personalelevator == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>პერსონალური ლიფტი</h5>
                                  <p>
                                    <strong>კი</strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {renderParamBox("elevator_all", "ლიფტების რაოდენობა", {
                              amount: "elevator_all_amount",
                            })}

                            {renderParamBox("openpool", "ღია აუზი", {
                              amount: "openpoolamount",
                            })}

                            {renderParamBox("Indoorpool", "დახურული აუზი", {
                              amount: "Indoorpoolamount",
                            })}

                            {property?.fireplace == "yes" ? (
                              <div className="mainParamBox">
                                <div className="paramIcon">
                                  <FontAwesomeIcon icon={faCheckSquare} />
                                </div>
                                <div className="paramText">
                                  <h5>ბუხარი</h5>
                                  <p>
                                    რაოდენობა:
                                    <strong>
                                      {property?.fireplaceamount != null
                                        ? property.fireplaceamount
                                        : ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {property?.hotwater ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ცხელი წყალი</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.hotwater?.includes(
                                  "centralheating",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ცენტრალური გათბობის სისტემა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hotwater?.includes("gasheater") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>
                                          გაზის ინდივიდუალური გამაცხელებელი
                                        </h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hotwater?.includes("tank") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ავზი - ბოილერი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hotwater?.includes(
                                  "electricheater",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>
                                          დენის ინდივიდუალური გამაცხელებელი
                                        </h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hotwater?.includes(
                                  "naturalhotwater",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ბუნებრივი ცხელი წყალი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.hotwater?.includes("solarheater") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მზის სისტემები</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.heating ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>გათბობა</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.heating?.includes(
                                  "centralheating",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ცენტრალური გათბობა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.heating?.includes("gasheater") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გაზის ინდივიდუალური გამათბობელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.heating?.includes("floorheating") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>იატაკის გათბობა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.heating?.includes("powerheater") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>დენის ინდივიდუალური გამათბობელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.heating?.includes("chiller") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ჩილერი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.heating?.includes("solarheater") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მზის გამათბობელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.generalamenities ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ზოგადი კეთილმოწყობა</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.generalamenities?.includes(
                                  "naturalgas",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საკაბელო ტელევიზია</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.generalamenities?.includes(
                                  "generator",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გენერატორი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.generalamenities?.includes(
                                  "internet",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ინტერნეტი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.generalamenities?.includes(
                                  "television",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ტელევიზია</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.generalamenities?.includes(
                                  "alarmsystem",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სიგნალიზაცია</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.generalamenities?.includes(
                                  "satelit",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სატელიტური თეფში</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.generalamenities?.includes(
                                  "solarPanel",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მზის ენერგიის პანელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.generalamenities?.includes(
                                  "personaltransformator",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საკუთარი ტრანსფორმატორი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.generalamenities?.includes(
                                  "ventilation",
                                ) ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ვენტილაცია</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {renderGroupItems("generalamenities", [
                                  ["telephone", "ტელეფონი"],
                                ])}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.facade1 ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ფასადი</h3>

                            <div className="propertyDetailsProp">
                              <Row>
                                {property?.facade1?.includes("galesili") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გალესილი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facadeadded1") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მიუნხენი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facadeadded2") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ესპანკა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facadeadded3") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>XPS</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facadeadded4") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ბრიზგი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facadeadded5") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მარმარილო</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facadeadded6") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ტუფი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facadeadded7") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გიბსოკარდონი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facadePanel") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ფასადის პანელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("aguri") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>აგური</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("traventili") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ტრავენტილი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("xisPaneli") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხის პანელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("hplPanel") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>HPL პანელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("combined") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კომბინირებული</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("minapacket") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მინაპაკეტი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facadestone") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ფასადის ქვა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("quartz") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კვარცი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("onyx") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ონიქსი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("ceramic") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კერამოგრანიტი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.facade1?.includes("facade_block") ? (
                                  <Col xxl={6}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ფასადის ბლოკი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {renderGroupItems("facade1", [
                                  ["thermally_treated_wood", "თერმულად დამუშავებული ხე"],
                                  ["fiber_cement_panels", "ფიბროცემენტის პანელი"],
                                  ["alucobond_ventilated_facade", "ალუკობონდის ფასადი"],
                                  ["exterior_facade_decor", "გარე ფასადის დეკორი"],
                                  ["steel_sheet", "ფოლადის ფირფიტა"],
                                  ["plaster", "თაბაშირი"],
                                ])}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.road ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>გზა</h3>

                            {property?.road?.includes("concrete") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ბეტონის</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.road?.includes("asphalted") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ასფალტის</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.road?.includes("pavingstone") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ქვაფენილი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.road?.includes("graveled") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>მოხრეშილი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.road?.includes("soil") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>გრუნტი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.buildingmaterial ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>აშენების მასალა</h3>

                            {property?.buildingmaterial?.includes("block") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ბლოკი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes("brick") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>აგური</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes("stone") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ქვა</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes("wood") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ხე</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes(
                              "pumiceblock",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>პემზის ბლოკი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes(
                              "reinforcedconcrete",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>რკინა-ბეტონი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes(
                              "sendvichPanel",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>სენდვიჩ პანელი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes(
                              "minaPaket",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>მინა პაკეტი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes(
                              "combined",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>კომბინირებული</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes(
                              "concrete_block",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ბეტონის ბლოკი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes(
                              "polytech_block",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>პოლიტექ ბლოკი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes(
                              "air_block",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>აირ ბლოკი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes(
                              "aluminum_structure",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ალუმინის კონსტრუქცია</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.buildingmaterial?.includes("zinc") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>სინკარი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.doorandwindow ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>კარ-ფანჯრის ტიპი-მასალა</h3>

                            {property?.doorandwindow?.includes(
                              "doorwindow1",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ვიტრაჟული</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.doorandwindow?.includes(
                              "doorwindow2",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>სლაიდი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.doorandwindow?.includes(
                              "doorwindow3",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>მინაპაკეტი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.doorandwindow?.includes(
                              "doorwindow4",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ახალი ხე</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.doorandwindow?.includes(
                              "doorwindow5",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ძველი ხე</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.doorandwindow?.includes(
                              "doorwindow6",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>მეტალო პლასტმასი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.doorandwindow?.includes(
                              "doorwindow7",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ალუმინი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.doorandwindow?.includes(
                              "doorwindow8",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>კომბინირებული</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.doorandwindow?.includes(
                              "doorwindow9",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>მასიური ხე</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.overlap ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>გადახურვის ტიპი</h3>

                            {property?.overlap?.includes("flat") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ბრტყელი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlap?.includes("conical") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>კონუსებური</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlap?.includes("tagovani") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>თაღოვანი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlap?.includes("piramid") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>პირამიდული</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlap?.includes("valmur") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ვალმური</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlap?.includes("gambler") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>გამბლერის სახურავი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlap?.includes("mansard") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>მანსარდული</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {renderGroupItems("overlap", [
                              ["tinroofing", "თუნუქის გადახურვა"],
                              ["corrugatedroofing", "ტოლით გადახურვა"],
                              ["tileroof", "კრამიტის სახურავი"],
                              ["sendvich", "სენდვიჩ პანელი"],
                              ["beton", "ბეტონი"],
                            ])}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.overlapmaterial ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>გადახურვის მასალა</h3>

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial1",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ტოლი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial2",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ბიტუმ-პოლიმერი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial3",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ბეტონი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial4",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>სენდვიჩპანელი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial5",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>კრამიტი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial6",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>შინგლი (რბილი კრამიტი)</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial7",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>შიფერი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial8",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ევროშიფერი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial9",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>თუნუქის</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial10",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>მეტალოკრამიტი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial11",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>პოლიკარბონატი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial12",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>მინის სახურავი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial13",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>მინა პაკეტი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial14",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ხის სახურავი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.overlapmaterial?.includes(
                              "overlapmaterial15",
                            ) ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ქვის სახურავი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.fundament ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ფუნდამენტის ტიპი</h3>
                            {property?.fundament?.includes("lent") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ლენტოვანი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.fundament?.includes("khiminji") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ხიმინჯი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.fundament?.includes("balishovani") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>ბალიშოვანი (ფილა)</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.fundament?.includes("dotted") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>წერტილოვანი</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.fundament?.includes("combined") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>კომბინიებული</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}

                            {property?.fundament?.includes("no_foundation") ? (
                              <Col xxl={4}>
                                <div className="mainListParamBox">
                                  <div className="paramListIcon">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                  </div>
                                  <div className="paramListText">
                                    <h5>საძირკვლის არმქონე</h5>
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.furniture ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ავეჯი</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.furniture?.includes(
                                  "livingroomfurniture",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მისაღები ოთახის ავეჯი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.furniture?.includes(
                                  "softfurniture",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>რბილი ავეჯი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.furniture?.includes(
                                  "kitchenfurniture",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სამზარეულოს ავეჯი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.furniture?.includes(
                                  "bedroomfurniture",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საძინებლის ავეჯი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.furniture?.includes(
                                  "summerfurniture",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საზაფხულო ავეჯი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.furniture?.includes(
                                  "officefurniture",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საოფისე ავეჯი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.furniture?.includes(
                                  "childrensfurniture",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საბავშვო ავეჯი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.furniture?.includes(
                                  "partiallyfurnished",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ნაწილობრივ ავეჯი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.furniture?.includes(
                                  "unfurnished",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კაბინეტის გარეშე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.technic ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ტექნიკა</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.technic?.includes("television") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ტელევიზორი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("refrigerator") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მაცივარი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes(
                                  "microwaveoven",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მიკროტალღური ღუმელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("dishwasher") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ჭურჭლის სარეცხი მანქანა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes(
                                  "washingmachine",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სარეცხი მანქანა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes(
                                  "airconditioner",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კონდინციონერი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("stereosystem") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მუსიკალური ცენტრი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("rangehood") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გამწოვი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("stove") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გაზქურა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes(
                                  "vacuumcleaner",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მტვერსასრუტი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("iron") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>უთო</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("homecinema") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კინოთეატრი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("dryer") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საშრობი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("coffeemaker") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ყავის აპარატი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes(
                                  "electrickettle",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ელექტრო ჩაიდანი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("toaster") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ტოსტერი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("juicer") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>წვენსაწური</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("mixer") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მიქსერი / ბლენდერი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("blender") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გრილი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("meatgrinder") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხორცის საკეპი მანქანა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("computer") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კომპიუტერი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes(
                                  "printerscannerxerox",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>პრინტერი / სკანერი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes("safe") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სეიფი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.technic?.includes(
                                  "fitnessequipment",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სპორტული ტრენაჟორები</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {renderGroupItems("technic", [
                                  ["generator", "გენერატორი"],
                                  ["grill", "გრილი / მაყალი"],
                                ])}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.security ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>დაცვის სერვისი</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.security?.includes("alarmsystem") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სიგნალიზაცია</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.security?.includes(
                                  "livesecurity",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ცოცხალი დაცვა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.security?.includes("cctvcameras") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ვიდეო კამერები</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.security?.includes(
                                  "entranceaccesssystem",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სადარბაზოს დაშვების სისტემა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.security?.includes(
                                  "gatedaccesssystem",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ეზოს დაშვების სისტემა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {renderGroupItems("security", [
                                  ["barrier", "შლაგბაუმი"],
                                ])}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.smarthouse ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ჭკვიანი სახლი</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.smarthouse?.includes(
                                  "controlpanels",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მართვის პანელები</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.smarthouse?.includes(
                                  "securitysystems",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>უსაფრთხოების სისტემები</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.smarthouse?.includes(
                                  "smartcamera",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ჭკვიანი კამერა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.smarthouse?.includes(
                                  "curtainblind",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ფარდა ჟალუზი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.smarthouse?.includes(
                                  "lightingautomation",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>განათების ავტომატიზირება</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.smarthouse?.includes("smartlock") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ჭკვიანი საკეტი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.smarthouse?.includes(
                                  "householdappliancecontrol",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საყოფაცხოვრებო ტექნიკის მართვა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.smarthouse?.includes(
                                  "audiosystem",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>აუდიო სისტემა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.smarthouse?.includes(
                                  "audiosystem",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>აუდიო სისტემა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.smarthouse?.includes(
                                  "smartintercom",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ჭკვიანი დომოფონი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {renderGroupItems("smarthouse", [
                                  ["smartring", "ჭკვიანი ზარები"],
                                  ["smartrwatering", "ჭკვიანი სარწყავი სისტემა"],
                                  ["smartdoorsensor", "კარის და ფანჯრის სენსორი"],
                                  ["smartswitch", "ჭკვიანი ჩამრთველი"],
                                  ["smartthermostat", "ჭკვიანი თერმოსტატი"],
                                  ["smartairconditioner", "კონდინციონერის მართვა"],
                                  ["smartspeaker", "ხმოვანი ასისტენტი"],
                                  ["smartelectronics", "ჭკვიანი ელექტრო მოწყობილობები"],
                                ])}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.additionaladvantages ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>დამატებითი უპირატესობები</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.additionaladvantages?.includes(
                                  "organizedinfrastructure",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მოწესრიგებული ინფრასტრუქტურა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "gamcholi",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გამჭოლი ბინა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "kutxisbina",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კუთხის ბინა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "qimwmenda",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ქიმწმენდა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "dasufTavebaezo",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>დასუფთავება (ეზო)</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "dasufTavebalifti",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>დასუფთავება (სადარბაზო, ლიფტი)</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "technikurimomsaxureba",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ტექნიკური მომსახურება</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "gamwvanebismovla",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გამწვანების მოვლა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "panoramicview",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>პანორამული ხედი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "cityview",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხედი ქალაქზე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "seaview",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხედი ზღვაზე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "mountainview",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხედი მთაზე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "riverview",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხედი მდინარეზე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "lakeview",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხედი ტბაზე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "courtyardview",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხედი ეზოში</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "bright",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ნათელი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "stainedglasswindowdoor",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ვიტრაჟული კარ-ფანჯარა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "landscaping",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გამწვანება</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "childrenspace",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საბავშვო სივრცე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "sportsfield",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სპორტული მოედანი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "padelfield",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>პადელის მოედანი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "bikeroad",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ველობილიკი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "concierge",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კონსიაჟი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "coworkingspace",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საერთო სამუშაო სივრცე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "businesslobby",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ბიზნეს ლობი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "cafeteria",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კაფეტერია</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "restaurant",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>რესტორანი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "restaurantonterace",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>რესტორანი ტერასაზე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "conferencehall",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საკონფერენციო დარბაზი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "eventhall",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ივენთ ჰოლი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "commercialspace",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კომერციული ფართი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "residentiallobby",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საცხოივრებელი ლობი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "freewifi",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>უფასო Wifi</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "laundry",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სამრეცხაო</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "spacenter",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სპა ცენტრი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "sauna",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საუნა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "fitnessroom",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ფიტნეს დარბაზი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "tenniscourts",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კორტები</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "golfcourse",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>გოლფის მოედანი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "multifunctional",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მულტიფუნქციური</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "energyefficient",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ენერგო ეფექტური ფანჯარა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "modernarchitecture",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>თანამედროვე არქიტექტურა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "glazedbalconies",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>შემინული აივნები</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "jacuzzi",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ჯაკუზი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "showercabinplusbathtub",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>დუშ კაბინა + ვანა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "electriccarservice",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ელექტრომობილით მომსახურება</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "nulovanizoli",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ნულოვანი ზოლი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "360view",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>360° ხედი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "goodlocation",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კარგი ლოკაცია</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "completedbuilding",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ჩაბარებული კორპუსი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "aclasslift",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>A კლასის ლიფტი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "hoteltypeapartment",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სასტუმროს ტიპის აპარტამენტი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "shoppingcenter",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სავაჭრო ცენტრი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "quietness",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>სიმყუდროვე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "panoramicpool",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>პანორამული აუზი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "investmentapartments",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საინვესტიციო ბინები</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "childrenspool",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საბავშვო აუზი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "olympicpool",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ოლიმპიური აუზი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "aquapark",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>აკვაპარკი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionaladvantages?.includes(
                                  "privatebeach",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კერძო სანაპირო ზოლი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {renderGroupItems("additionaladvantages", [
                                  ["seismically_safe", "სეისმურად უსაფრთხო"],
                                  ["sound_insulation", "ხმის იზოლაცია"],
                                  ["modern_construction_material", "თანამედროვე სამშენებლო მასალა"],
                                  ["dry_sauna", "მშრალი საუნა"],
                                  ["turkish_sauna", "თურქული საუნა"],
                                  ["finnish_sauna", "ფინური საუნა"],
                                  ["shower", "საშხაპე"],
                                  ["artificial_waterfall", "ხელოვნური ჩანჩქერი"],
                                  ["panoramic_elevator", "პანორამული ლიფტი"],
                                  ["electric_car_charger", "ელექტრომობილის დამტენი"],
                                  ["recreation_area", "რეკრეაციული ზონა"],
                                  ["car_wash", "ავტომობილების რეცხვა"],
                                  ["beach_club", "ბიჩ ქლაბი"],
                                  ["free_layout", "თავისუფალი გეგმარება"],
                                  ["helipad", "ვერტმფრენის დასაჯდომი"],
                                ])}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.additionalsecurity ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>დამატებითი უსაფრთხოება</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.additionalsecurity?.includes(
                                  "evacuationstaircase",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>საევაკუაციო კიბე</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionalsecurity?.includes(
                                  "firesafetyssystem",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>ხანძრის საწინააღმდეგო სისტემა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionalsecurity?.includes(
                                  "codetector",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>CO დეტექტორი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.additionalsecurity?.includes(
                                  "smokedetector",
                                ) ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>კვამლის დეტექტორი</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {renderGroupItems("additionalsecurity", [
                                  ["fireextinguisher", "ცეცხლმაქრი"],
                                  ["water_reservoir", "წყლის რეზერვუარი"],
                                ])}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.citycenter || property?.busstop || property?.shoppingcenter || property?.school || property?.kindergarten || property?.metrosstation || property?.cinema || property?.square || property?.museum || property?.restaurant || property?.supermarket || property?.pharmacy || property?.hospital || property?.railwaystation || property?.airport || property?.sea || property?.river || property?.lake1 || property?.naturereserve || property?.forest || property?.university || property?.sportstadium || property?.bank || property?.sportgym || property?.boulvar || property?.fastfood || property?.currencyexchange || property?.nightclub || property?.cafe_bar || newNearObjects.some(([field]) => property?.[field]) ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>ობიექტთან ახლოს</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.citycenter ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ქალაქის ცენტრი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.citycenter_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.citycenter_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.busstop ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ავტობუსის გაჩერება</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.busstop_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.busstop_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.shoppingcenter ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სავაჭრო ცენტრი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.shoppingcenter_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {
                                                property?.shoppingcenter_distance
                                              }{" "}
                                              მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.school ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სკოლა</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.school_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.school_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.kindergarten ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>საბავშვო ბაღი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.kindergarten_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.kindergarten_distance}{" "}
                                              მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.metrosstation ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>
                                            მეტროსადგური
                                            {hasValue(property?.metrosstation_options)
                                              ? " - " +
                                              optionLabel(
                                                Options.metroStationOptions,
                                                property.metrosstation_options,
                                              )
                                              : ""}
                                          </h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.metro_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.metro_distance}{" "}
                                              მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.cinema ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>კინოთეატრი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.cinema_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.cinema_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.square ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სკვერი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.square_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.square_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.museum ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>მუზეუმი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.museum_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.museum_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.restaurant ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>რესტორანი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.restaurant_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.restaurant_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.supermarket ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სუპერმარკეტი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.supermarket_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.supermarket_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.pharmacy ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>აფთიაქი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.pharmacy_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.pharmacy_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.hospital ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>საავადმყოფო</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.hospital_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.hospital_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.railwaystation ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>რკინიგზის სადგური</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.railwaystation_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {
                                                property?.railwaystation_distance
                                              }{" "}
                                              მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.airport ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>აეროპორტი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.airport_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.airport_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.sea ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ზღვა</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.sea_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>{property?.sea_distance} მ</h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.river ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>მდინარე</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.river_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.river_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.lake1 ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ტბა</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.lake_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>{property?.lake_distance} მ</h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.naturereserve ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ნაკრძალი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.naturereserve_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.naturereserve_distance}{" "}
                                              მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.forest ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ტყე</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.forest_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.forest_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.university ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>უნივერსიტეტი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.university_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.university_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.sportstadium ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სპორტული მოედანი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.sportstadium_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.sportstadium_distance}{" "}
                                              მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.bank ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ბანკი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.bank_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>{property?.bank_distance} მ</h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.sportgym ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სპორტული დარბაზი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.sportgym_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.sportgym_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.boulvar ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ბულვარი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.boulvar_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.boulvar_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.fastfood ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>სწრაფი კვება</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.fastfood_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.fastfood_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.currencyexchange ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ვალუტის ჯიხური</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.currencyexchange_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {
                                                property?.currencyexchange_distance
                                              }{" "}
                                              მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.nightclub ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>ღამის კლუბი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.nightclub_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.nightclub_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {property?.cafe_bar ? (
                                  <Row className="w-100 mb-2">
                                    <Col xxl={6}>
                                      <div className="mainListParamBox">
                                        <div className="paramListIcon">
                                          <FontAwesomeIcon
                                            icon={faCheckSquare}
                                          />
                                        </div>
                                        <div className="paramListText">
                                          <h5>კაფე-ბარი</h5>
                                        </div>
                                      </div>
                                    </Col>
                                    {property?.cafe_bar_distance ? (
                                      <Col xxl={6}>
                                        <div className="mainListParamBox">
                                          <div className="paramListText">
                                            <h5>
                                              {property?.cafe_bar_distance} მ
                                            </h5>
                                          </div>
                                        </div>
                                      </Col>
                                    ) : (
                                      ""
                                    )}
                                  </Row>
                                ) : (
                                  ""
                                )}

                                {newNearObjects.map(([field, label]) =>
                                  renderNearObject(field, label, `${field}_distance`),
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {finishingMaterials.some(([field]) => hasValue(property?.[field])) ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>მშენებლობის მასალა - ტიპი</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {finishingMaterials.map(([field, label]) =>
                                  renderInfoBox(label, property?.[field]),
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}

                  {property?.allowed ? (
                    <div className="detailsCardBox">
                      <Row>
                        <Col xxl={12}>
                          <div className="propertyDetailsProp">
                            <h3>დაშვებულია</h3>

                            <div className="propertyDetailsPropBox">
                              <Row>
                                {property?.allowed?.includes("eventhosting") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>წვეულების გამართვა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.allowed?.includes("pets") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>შინაური ცხოველები</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}

                                {property?.allowed?.includes("smoking") ? (
                                  <Col xxl={4}>
                                    <div className="mainListParamBox">
                                      <div className="paramListIcon">
                                        <FontAwesomeIcon icon={faCheckSquare} />
                                      </div>
                                      <div className="paramListText">
                                        <h5>მოწევა</h5>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </Col>

            <Col xxl={4}>
              <div className="propertyDetailsRight">
                <div className="singleProductPrice">
                  {["GEL", "USD", "EUR"].includes(currentCurrency) && (
                    <>
                      <h4>
                        {property?.[`price_${currentCurrency.toLowerCase()}`] !=
                          null
                          ? property?.[`price_${currentCurrency.toLowerCase()}`]
                          : ""}
                        <span>{currentCurrency}</span>
                      </h4>
                    </>
                  )}
                  <div className="priceBoxDetails">
                    <div
                      className={`singlePropertyPrice ${currentCurrency === "GEL" ? "active" : ""
                        }`}
                      onClick={() => toggleCurrency("GEL")}
                    >
                      <p>GEL</p>
                    </div>
                    <div
                      className={`singlePropertyPrice ${currentCurrency === "USD" ? "active" : ""
                        }`}
                      onClick={() => toggleCurrency("USD")}
                    >
                      <p>USD</p>
                    </div>
                    <div
                      className={`singlePropertyPrice ${currentCurrency === "EUR" ? "active" : ""
                        }`}
                      onClick={() => toggleCurrency("EUR")}
                    >
                      <p>EUR</p>
                    </div>
                  </div>
                </div>
                <div className="oneSquarePrice">
                  <p>
                    1 მ<sup>2</sup>{" "}
                    <span>
                      {(
                        property?.[`price_${currentCurrency.toLowerCase()}`] /
                        property?.area
                      ).toFixed(0)}{" "}
                      {currentCurrency}
                    </span>
                  </p>
                </div>

                <div className="oneSquareArea">
                  <p>
                    ფართი{" "}
                    <span>
                      {property?.area != null ? property.area : ""} მ
                      <sup>2</sup>
                    </span>
                  </p>
                </div>

                <div className="adAuthor">
                  <Link to="/">
                    <div className="adAuthorImg">
                      <h4>R</h4>
                    </div>
                  </Link>
                  <div className="adAuthorText">
                    <Link to="/">
                      <h5>Relux</h5>
                    </Link>
                    <p>დაგვიკავშირდით</p>
                  </div>
                </div>

                <a href="tel:+995 555 123 456">
                  <div className="adAuthorPhone">
                    <FontAwesomeIcon icon={faMobileScreen} />
                    <div className="phoneNumber">+995 555 123 456</div>
                  </div>
                </a>

                <a href="mailto:info@relux.ge">
                  <div className="adAuthorPhone">
                    <FontAwesomeIcon icon={faEnvelope} />
                    <div className="phoneNumber">info@relux.ge</div>
                  </div>
                </a>
              </div>

              <div className="banner_inside">
                <Link to="https://reluxapp.myweb.com.ge" target="_blank">
                  <div className="bannerInsideSection">
                    <Image src={Bannerinside} alt="Relux" />
                  </div>
                </Link>
              </div>
            </Col>

            {/* <Col xxl={12}>
              <div className="relatedAds">
                <h6>მსგავსი განცხადებები</h6>
                <Swiper
                  modules={[Navigation, A11y]}
                  spaceBetween={5}
                  slidesPerView={4}
                  navigation
                  scrollbar={{ draggable: true }}
                >
                  <SwiperSlide>
                    <div className="singleProductGridBox">
                      {message && (
                        <div className="addedToFafourites">
                          <h4>{message}</h4>
                        </div>
                      )}
                      <div className="singleProductGridBoxImageBox">
                        <Link to={`/${locale}/property/details/`}>
                          <Swiper
                            modules={[Navigation, A11y]}
                            spaceBetween={20}
                            slidesPerView={1}
                            navigation
                            scrollbar={{ draggable: true }}
                          >
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                          </Swiper>
                        </Link>
                        <div className="singleProductGridTag">
                          <Link to="/">
                            <h4>ექსკლუზიური</h4>
                          </Link>
                        </div>
                        <div
                          className="singleProductGridFavourite"
                          onClick={toggleFavourite}
                        >
                          <FontAwesomeIcon
                            icon={isFavourite ? faHeart : faHeartRegular}
                          />
                        </div>
                        <div className="singleProductGridPrice">
                          <h4>
                            180000 <span>{currentCurrency}</span>
                          </h4>
                          <div className="priceBoxGrid">
                            <div
                              className={`singlePrice ${
                                currentCurrency === "GEL" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("GEL")}
                            >
                              <p>GEL</p>
                            </div>
                            <div
                              className={`singlePrice ${
                                currentCurrency === "USD" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("USD")}
                            >
                              <p>USD</p>
                            </div>
                            <div
                              className={`singlePrice ${
                                currentCurrency === "EUR" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("EUR")}
                            >
                              <p>EUR</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="singleProductGridBoxContant">
                        <div className="propertyGridTags">
                          <div className="singleTag">ბინა</div>
                          <div className="singleTag">თბილისი</div>
                        </div>
                        <Link to={`/${locale}/property/details/`}>
                          <h1>
                            იყიდება 5 ოთახიანი კერძო სახლი თბილისთან ახლოს
                          </h1>
                        </Link>
                        <div className="singlePropertyGridLocation">
                          <FontAwesomeIcon icon={faLocationCrosshairs} />
                          <p>ა.წერეთლის გამზირი #137, 0119</p>
                        </div>
                        <div className="singlePropertyListMiniBox">
                          <div
                            className="singlePropertyGridMini"
                            title="საძინებელი"
                          >
                            <FontAwesomeIcon icon={faBed} />: <span>4</span>
                          </div>
                          <div className="singlePropertyGridMini" title="ოთახი">
                            <FontAwesomeIcon icon={faDoorOpen} />
                            <span>3</span>
                          </div>
                          <div
                            className="singlePropertyGridMini"
                            title="სართული"
                          >
                            <FontAwesomeIcon icon={faLayerGroup} />
                            <span>12/14</span>
                          </div>
                          <div className="singlePropertyGridMini" title="ფართი">
                            <FontAwesomeIcon icon={faClone} />
                            <span>
                              120 მ<sup>2</sup>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="singleProductGridBox">
                      {message && (
                        <div className="addedToFafourites">
                          <h4>{message}</h4>
                        </div>
                      )}
                      <div className="singleProductGridBoxImageBox">
                        <Link to={`/${locale}/property/details/`}>
                          <Swiper
                            modules={[Navigation, A11y]}
                            spaceBetween={5}
                            slidesPerView={1}
                            navigation
                            scrollbar={{ draggable: true }}
                          >
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                          </Swiper>
                        </Link>
                        <div className="singleProductGridTag">
                          <Link to="/">
                            <h4>ექსკლუზიური</h4>
                          </Link>
                        </div>
                        <div
                          className="singleProductGridFavourite"
                          onClick={toggleFavourite}
                        >
                          <FontAwesomeIcon
                            icon={isFavourite ? faHeart : faHeartRegular}
                          />
                        </div>
                        <div className="singleProductGridPrice">
                          <h4>
                            180000 <span>{currentCurrency}</span>
                          </h4>
                          <div className="priceBoxGrid">
                            <div
                              className={`singlePrice ${
                                currentCurrency === "GEL" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("GEL")}
                            >
                              <p>GEL</p>
                            </div>
                            <div
                              className={`singlePrice ${
                                currentCurrency === "USD" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("USD")}
                            >
                              <p>USD</p>
                            </div>
                            <div
                              className={`singlePrice ${
                                currentCurrency === "EUR" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("EUR")}
                            >
                              <p>EUR</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="singleProductGridBoxContant">
                        <div className="propertyGridTags">
                          <div className="singleTag">ბინა</div>
                          <div className="singleTag">თბილისი</div>
                        </div>
                        <Link to={`/${locale}/property/details/`}>
                          <h1>
                            იყიდება 5 ოთახიანი კერძო სახლი თბილისთან ახლოს
                          </h1>
                        </Link>
                        <div className="singlePropertyGridLocation">
                          <FontAwesomeIcon icon={faLocationCrosshairs} />
                          <p>ა.წერეთლის გამზირი #137, 0119</p>
                        </div>
                        <div className="singlePropertyListMiniBox">
                          <div
                            className="singlePropertyGridMini"
                            title="საძინებელი"
                          >
                            <FontAwesomeIcon icon={faBed} />: <span>4</span>
                          </div>
                          <div className="singlePropertyGridMini" title="ოთახი">
                            <FontAwesomeIcon icon={faDoorOpen} />
                            <span>3</span>
                          </div>
                          <div
                            className="singlePropertyGridMini"
                            title="სართული"
                          >
                            <FontAwesomeIcon icon={faLayerGroup} />
                            <span>12/14</span>
                          </div>
                          <div className="singlePropertyGridMini" title="ფართი">
                            <FontAwesomeIcon icon={faClone} />
                            <span>
                              120 მ<sup>2</sup>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="singleProductGridBox">
                      {message && (
                        <div className="addedToFafourites">
                          <h4>{message}</h4>
                        </div>
                      )}
                      <div className="singleProductGridBoxImageBox">
                        <Link to={`/${locale}/property/details/`}>
                          <Swiper
                            modules={[Navigation, A11y]}
                            spaceBetween={5}
                            slidesPerView={1}
                            navigation
                            scrollbar={{ draggable: true }}
                          >
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                          </Swiper>
                        </Link>
                        <div className="singleProductGridTag">
                          <Link to="/">
                            <h4>ექსკლუზიური</h4>
                          </Link>
                        </div>
                        <div
                          className="singleProductGridFavourite"
                          onClick={toggleFavourite}
                        >
                          <FontAwesomeIcon
                            icon={isFavourite ? faHeart : faHeartRegular}
                          />
                        </div>
                        <div className="singleProductGridPrice">
                          <h4>
                            180000 <span>{currentCurrency}</span>
                          </h4>
                          <div className="priceBoxGrid">
                            <div
                              className={`singlePrice ${
                                currentCurrency === "GEL" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("GEL")}
                            >
                              <p>GEL</p>
                            </div>
                            <div
                              className={`singlePrice ${
                                currentCurrency === "USD" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("USD")}
                            >
                              <p>USD</p>
                            </div>
                            <div
                              className={`singlePrice ${
                                currentCurrency === "EUR" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("EUR")}
                            >
                              <p>EUR</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="singleProductGridBoxContant">
                        <div className="propertyGridTags">
                          <div className="singleTag">ბინა</div>
                          <div className="singleTag">თბილისი</div>
                        </div>
                        <Link to={`/${locale}/property/details/`}>
                          <h1>
                            იყიდება 5 ოთახიანი კერძო სახლი თბილისთან ახლოს
                          </h1>
                        </Link>
                        <div className="singlePropertyGridLocation">
                          <FontAwesomeIcon icon={faLocationCrosshairs} />
                          <p>ა.წერეთლის გამზირი #137, 0119</p>
                        </div>
                        <div className="singlePropertyListMiniBox">
                          <div
                            className="singlePropertyGridMini"
                            title="საძინებელი"
                          >
                            <FontAwesomeIcon icon={faBed} />: <span>4</span>
                          </div>
                          <div className="singlePropertyGridMini" title="ოთახი">
                            <FontAwesomeIcon icon={faDoorOpen} />
                            <span>3</span>
                          </div>
                          <div
                            className="singlePropertyGridMini"
                            title="სართული"
                          >
                            <FontAwesomeIcon icon={faLayerGroup} />
                            <span>12/14</span>
                          </div>
                          <div className="singlePropertyGridMini" title="ფართი">
                            <FontAwesomeIcon icon={faClone} />
                            <span>
                              120 მ<sup>2</sup>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="singleProductGridBox">
                      {message && (
                        <div className="addedToFafourites">
                          <h4>{message}</h4>
                        </div>
                      )}
                      <div className="singleProductGridBoxImageBox">
                        <Link to={`/${locale}/property/details/`}>
                          <Swiper
                            modules={[Navigation, A11y]}
                            spaceBetween={5}
                            slidesPerView={1}
                            navigation
                            scrollbar={{ draggable: true }}
                          >
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="singleProductGridBoxImage">
                                <Image
                                  src={Propertyimage}
                                  alt="Property image"
                                />
                              </div>
                            </SwiperSlide>
                          </Swiper>
                        </Link>
                        <div className="singleProductGridTag">
                          <Link to="/">
                            <h4>ექსკლუზიური</h4>
                          </Link>
                        </div>
                        <div
                          className="singleProductGridFavourite"
                          onClick={toggleFavourite}
                        >
                          <FontAwesomeIcon
                            icon={isFavourite ? faHeart : faHeartRegular}
                          />
                        </div>
                        <div className="singleProductGridPrice">
                          <h4>
                            180000 <span>{currentCurrency}</span>
                          </h4>
                          <div className="priceBoxGrid">
                            <div
                              className={`singlePrice ${
                                currentCurrency === "GEL" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("GEL")}
                            >
                              <p>GEL</p>
                            </div>
                            <div
                              className={`singlePrice ${
                                currentCurrency === "USD" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("USD")}
                            >
                              <p>USD</p>
                            </div>
                            <div
                              className={`singlePrice ${
                                currentCurrency === "EUR" ? "active" : ""
                              }`}
                              onClick={() => toggleCurrency("EUR")}
                            >
                              <p>EUR</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="singleProductGridBoxContant">
                        <div className="propertyGridTags">
                          <div className="singleTag">ბინა</div>
                          <div className="singleTag">თბილისი</div>
                        </div>
                        <Link to={`/${locale}/property/details/`}>
                          <h1>
                            იყიდება 5 ოთახიანი კერძო სახლი თბილისთან ახლოს
                          </h1>
                        </Link>
                        <div className="singlePropertyGridLocation">
                          <FontAwesomeIcon icon={faLocationCrosshairs} />
                          <p>ა.წერეთლის გამზირი #137, 0119</p>
                        </div>
                        <div className="singlePropertyListMiniBox">
                          <div
                            className="singlePropertyGridMini"
                            title="საძინებელი"
                          >
                            <FontAwesomeIcon icon={faBed} />: <span>4</span>
                          </div>
                          <div className="singlePropertyGridMini" title="ოთახი">
                            <FontAwesomeIcon icon={faDoorOpen} />
                            <span>3</span>
                          </div>
                          <div
                            className="singlePropertyGridMini"
                            title="სართული"
                          >
                            <FontAwesomeIcon icon={faLayerGroup} />
                            <span>12/14</span>
                          </div>
                          <div className="singlePropertyGridMini" title="ფართი">
                            <FontAwesomeIcon icon={faClone} />
                            <span>
                              120 მ<sup>2</sup>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </Col> */}
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Detail;
